"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * FAD Open API
 * # Authentication  Add header `Authorization: Bearer {YOUR BEARER TOKEN}` to those authenticated requests.
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebhookToolApi = exports.WebhookToolApiFactory = exports.WebhookToolApiFp = exports.WebhookToolApiAxiosParamCreator = exports.WebhookLoaderApi = exports.WebhookLoaderApiFactory = exports.WebhookLoaderApiFp = exports.WebhookLoaderApiAxiosParamCreator = exports.WebhookBotApi = exports.WebhookBotApiFactory = exports.WebhookBotApiFp = exports.WebhookBotApiAxiosParamCreator = exports.UsersApi = exports.UsersApiFactory = exports.UsersApiFp = exports.UsersApiAxiosParamCreator = exports.ToolApi = exports.ToolApiFactory = exports.ToolApiFp = exports.ToolApiAxiosParamCreator = exports.TeamApi = exports.TeamApiFactory = exports.TeamApiFp = exports.TeamApiAxiosParamCreator = exports.TagApi = exports.TagApiFactory = exports.TagApiFp = exports.TagApiAxiosParamCreator = exports.ProjectApi = exports.ProjectApiFactory = exports.ProjectApiFp = exports.ProjectApiAxiosParamCreator = exports.OAuth2Api = exports.OAuth2ApiFactory = exports.OAuth2ApiFp = exports.OAuth2ApiAxiosParamCreator = exports.LoaderApi = exports.LoaderApiFactory = exports.LoaderApiFp = exports.LoaderApiAxiosParamCreator = exports.KnwlBaseApi = exports.KnwlBaseApiFactory = exports.KnwlBaseApiFp = exports.KnwlBaseApiAxiosParamCreator = exports.FetchApi = exports.FetchApiFactory = exports.FetchApiFp = exports.FetchApiAxiosParamCreator = exports.EnvironmentApi = exports.EnvironmentApiFactory = exports.EnvironmentApiFp = exports.EnvironmentApiAxiosParamCreator = exports.DeploymentApi = exports.DeploymentApiFactory = exports.DeploymentApiFp = exports.DeploymentApiAxiosParamCreator = exports.ContentfulApi = exports.ContentfulApiFactory = exports.ContentfulApiFp = exports.ContentfulApiAxiosParamCreator = exports.ChannelApi = exports.ChannelApiFactory = exports.ChannelApiFp = exports.ChannelApiAxiosParamCreator = exports.BotApi = exports.BotApiFactory = exports.BotApiFp = exports.BotApiAxiosParamCreator = exports.BlobApi = exports.BlobApiFactory = exports.BlobApiFp = exports.BlobApiAxiosParamCreator = exports.AuthApi = exports.AuthApiFactory = exports.AuthApiFp = exports.AuthApiAxiosParamCreator = exports.AgentApi = exports.AgentApiFactory = exports.AgentApiFp = exports.AgentApiAxiosParamCreator = exports.UserPositionUpsertJobPositionEnum = exports.UserMessageActionEnum = exports.ToolUpdatesVisibilityEnum = exports.ToolDtoOwnerTypeEnum = exports.ToolCreationOwnerTypeEnum = exports.ToolCreationVisibilityEnum = exports.TeamMemberUpdateRoleEnum = exports.TeamMemberDtoRoleEnum = exports.TagDtoDomainEnum = exports.SlackEventWrapperTypeEnum = exports.SlackEventSubtypeEnum = exports.SlackEventTypeEnum = exports.ProjectDtoOwnerTypeEnum = exports.ProjectCreationOwnerTypeEnum = exports.Oauth2ProviderDtoGrantTypeEnum = exports.OAuth2ProviderGrantTypeEnum = exports.LoaderUpdatesVisibilityEnum = exports.LoaderDtoVisibilityEnum = exports.LoaderDtoOwnerTypeEnum = exports.LoaderDeleteCallbackBodyModeEnum = exports.LoaderCreationVisibilityEnum = exports.LoaderCreationOwnerTypeEnum = exports.JsonNodeNodeTypeEnum = exports.FetchEventDtoLevelEnum = exports.FetchDtoStatusEnum = exports.EnvUpdateCoreVersionIdEnum = exports.EnvDtoCoreVersionIdEnum = exports.EnvCreationCoreVersionIdEnum = exports.DraftEnvCoreVersionIdEnum = exports.DeploymentDtoStatusEnum = exports.CommandDtoConfirmModeEnum = exports.CommandConfirmModeEnum = exports.BriefToolOwnerTypeEnum = exports.BriefTeamMemberDtoRoleEnum = exports.BriefEnvCoreVersionIdEnum = exports.BotDtoBotTypeEnum = exports.BotCreationBotTypeEnum = exports.ApiErrorCode = exports.ApiErrorStatusEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var ApiErrorStatusEnum;
(function (ApiErrorStatusEnum) {
    ApiErrorStatusEnum["_100Continue"] = "100 CONTINUE";
    ApiErrorStatusEnum["_101SwitchingProtocols"] = "101 SWITCHING_PROTOCOLS";
    ApiErrorStatusEnum["_102Processing"] = "102 PROCESSING";
    ApiErrorStatusEnum["_103Checkpoint"] = "103 CHECKPOINT";
    ApiErrorStatusEnum["_200Ok"] = "200 OK";
    ApiErrorStatusEnum["_201Created"] = "201 CREATED";
    ApiErrorStatusEnum["_202Accepted"] = "202 ACCEPTED";
    ApiErrorStatusEnum["_203NonAuthoritativeInformation"] = "203 NON_AUTHORITATIVE_INFORMATION";
    ApiErrorStatusEnum["_204NoContent"] = "204 NO_CONTENT";
    ApiErrorStatusEnum["_205ResetContent"] = "205 RESET_CONTENT";
    ApiErrorStatusEnum["_206PartialContent"] = "206 PARTIAL_CONTENT";
    ApiErrorStatusEnum["_207MultiStatus"] = "207 MULTI_STATUS";
    ApiErrorStatusEnum["_208AlreadyReported"] = "208 ALREADY_REPORTED";
    ApiErrorStatusEnum["_226ImUsed"] = "226 IM_USED";
    ApiErrorStatusEnum["_300MultipleChoices"] = "300 MULTIPLE_CHOICES";
    ApiErrorStatusEnum["_301MovedPermanently"] = "301 MOVED_PERMANENTLY";
    ApiErrorStatusEnum["_302Found"] = "302 FOUND";
    ApiErrorStatusEnum["_302MovedTemporarily"] = "302 MOVED_TEMPORARILY";
    ApiErrorStatusEnum["_303SeeOther"] = "303 SEE_OTHER";
    ApiErrorStatusEnum["_304NotModified"] = "304 NOT_MODIFIED";
    ApiErrorStatusEnum["_305UseProxy"] = "305 USE_PROXY";
    ApiErrorStatusEnum["_307TemporaryRedirect"] = "307 TEMPORARY_REDIRECT";
    ApiErrorStatusEnum["_308PermanentRedirect"] = "308 PERMANENT_REDIRECT";
    ApiErrorStatusEnum["_400BadRequest"] = "400 BAD_REQUEST";
    ApiErrorStatusEnum["_401Unauthorized"] = "401 UNAUTHORIZED";
    ApiErrorStatusEnum["_402PaymentRequired"] = "402 PAYMENT_REQUIRED";
    ApiErrorStatusEnum["_403Forbidden"] = "403 FORBIDDEN";
    ApiErrorStatusEnum["_404NotFound"] = "404 NOT_FOUND";
    ApiErrorStatusEnum["_405MethodNotAllowed"] = "405 METHOD_NOT_ALLOWED";
    ApiErrorStatusEnum["_406NotAcceptable"] = "406 NOT_ACCEPTABLE";
    ApiErrorStatusEnum["_407ProxyAuthenticationRequired"] = "407 PROXY_AUTHENTICATION_REQUIRED";
    ApiErrorStatusEnum["_408RequestTimeout"] = "408 REQUEST_TIMEOUT";
    ApiErrorStatusEnum["_409Conflict"] = "409 CONFLICT";
    ApiErrorStatusEnum["_410Gone"] = "410 GONE";
    ApiErrorStatusEnum["_411LengthRequired"] = "411 LENGTH_REQUIRED";
    ApiErrorStatusEnum["_412PreconditionFailed"] = "412 PRECONDITION_FAILED";
    ApiErrorStatusEnum["_413PayloadTooLarge"] = "413 PAYLOAD_TOO_LARGE";
    ApiErrorStatusEnum["_413RequestEntityTooLarge"] = "413 REQUEST_ENTITY_TOO_LARGE";
    ApiErrorStatusEnum["_414UriTooLong"] = "414 URI_TOO_LONG";
    ApiErrorStatusEnum["_414RequestUriTooLong"] = "414 REQUEST_URI_TOO_LONG";
    ApiErrorStatusEnum["_415UnsupportedMediaType"] = "415 UNSUPPORTED_MEDIA_TYPE";
    ApiErrorStatusEnum["_416RequestedRangeNotSatisfiable"] = "416 REQUESTED_RANGE_NOT_SATISFIABLE";
    ApiErrorStatusEnum["_417ExpectationFailed"] = "417 EXPECTATION_FAILED";
    ApiErrorStatusEnum["_418IAmATeapot"] = "418 I_AM_A_TEAPOT";
    ApiErrorStatusEnum["_419InsufficientSpaceOnResource"] = "419 INSUFFICIENT_SPACE_ON_RESOURCE";
    ApiErrorStatusEnum["_420MethodFailure"] = "420 METHOD_FAILURE";
    ApiErrorStatusEnum["_421DestinationLocked"] = "421 DESTINATION_LOCKED";
    ApiErrorStatusEnum["_422UnprocessableEntity"] = "422 UNPROCESSABLE_ENTITY";
    ApiErrorStatusEnum["_423Locked"] = "423 LOCKED";
    ApiErrorStatusEnum["_424FailedDependency"] = "424 FAILED_DEPENDENCY";
    ApiErrorStatusEnum["_425TooEarly"] = "425 TOO_EARLY";
    ApiErrorStatusEnum["_426UpgradeRequired"] = "426 UPGRADE_REQUIRED";
    ApiErrorStatusEnum["_428PreconditionRequired"] = "428 PRECONDITION_REQUIRED";
    ApiErrorStatusEnum["_429TooManyRequests"] = "429 TOO_MANY_REQUESTS";
    ApiErrorStatusEnum["_431RequestHeaderFieldsTooLarge"] = "431 REQUEST_HEADER_FIELDS_TOO_LARGE";
    ApiErrorStatusEnum["_451UnavailableForLegalReasons"] = "451 UNAVAILABLE_FOR_LEGAL_REASONS";
    ApiErrorStatusEnum["_500InternalServerError"] = "500 INTERNAL_SERVER_ERROR";
    ApiErrorStatusEnum["_501NotImplemented"] = "501 NOT_IMPLEMENTED";
    ApiErrorStatusEnum["_502BadGateway"] = "502 BAD_GATEWAY";
    ApiErrorStatusEnum["_503ServiceUnavailable"] = "503 SERVICE_UNAVAILABLE";
    ApiErrorStatusEnum["_504GatewayTimeout"] = "504 GATEWAY_TIMEOUT";
    ApiErrorStatusEnum["_505HttpVersionNotSupported"] = "505 HTTP_VERSION_NOT_SUPPORTED";
    ApiErrorStatusEnum["_506VariantAlsoNegotiates"] = "506 VARIANT_ALSO_NEGOTIATES";
    ApiErrorStatusEnum["_507InsufficientStorage"] = "507 INSUFFICIENT_STORAGE";
    ApiErrorStatusEnum["_508LoopDetected"] = "508 LOOP_DETECTED";
    ApiErrorStatusEnum["_509BandwidthLimitExceeded"] = "509 BANDWIDTH_LIMIT_EXCEEDED";
    ApiErrorStatusEnum["_510NotExtended"] = "510 NOT_EXTENDED";
    ApiErrorStatusEnum["_511NetworkAuthenticationRequired"] = "511 NETWORK_AUTHENTICATION_REQUIRED";
})(ApiErrorStatusEnum = exports.ApiErrorStatusEnum || (exports.ApiErrorStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ApiErrorCode;
(function (ApiErrorCode) {
    ApiErrorCode["UserNotFound"] = "USER_NOT_FOUND";
    ApiErrorCode["UserDisabled"] = "USER_DISABLED";
    ApiErrorCode["BlobNotFound"] = "BLOB_NOT_FOUND";
    ApiErrorCode["Forbidden"] = "FORBIDDEN";
    ApiErrorCode["Unauthorized"] = "UNAUTHORIZED";
    ApiErrorCode["UnexpectedError"] = "UNEXPECTED_ERROR";
    ApiErrorCode["InvalidRefreshCode"] = "INVALID_REFRESH_CODE";
    ApiErrorCode["InvalidBlobContentType"] = "INVALID_BLOB_CONTENT_TYPE";
    ApiErrorCode["InconsistentBotType"] = "INCONSISTENT_BOT_TYPE";
    ApiErrorCode["InvalidTelegramWebhookSecretToken"] = "INVALID_TELEGRAM_WEBHOOK_SECRET_TOKEN";
    ApiErrorCode["BotNotFound"] = "BOT_NOT_FOUND";
    ApiErrorCode["ProjectOwnerTypeError"] = "PROJECT_OWNER_TYPE_ERROR";
    ApiErrorCode["EnvNameError"] = "ENV_NAME_ERROR";
    ApiErrorCode["AgentInstanceNameError"] = "AGENT_INSTANCE_NAME_ERROR";
    ApiErrorCode["EnvVarNotFound"] = "ENV_VAR_NOT_FOUND";
    ApiErrorCode["EnvNotFound"] = "ENV_NOT_FOUND";
    ApiErrorCode["TeamMemberNotFound"] = "TEAM_MEMBER_NOT_FOUND";
    ApiErrorCode["TeamNotFound"] = "TEAM_NOT_FOUND";
    ApiErrorCode["EnvIsDraft"] = "ENV_IS_DRAFT";
    ApiErrorCode["DraftCannotBeDeleted"] = "DRAFT_CANNOT_BE_DELETED";
    ApiErrorCode["TeamMemberCannotBeDeleted"] = "TEAM_MEMBER_CANNOT_BE_DELETED";
    ApiErrorCode["TeamMemberCannotBeUpdated"] = "TEAM_MEMBER_CANNOT_BE_UPDATED";
    ApiErrorCode["TeamMemberNeedsAdmin"] = "TEAM_MEMBER_NEEDS_ADMIN";
    ApiErrorCode["SkillNotFound"] = "SKILL_NOT_FOUND";
    ApiErrorCode["AgentNotFound"] = "AGENT_NOT_FOUND";
    ApiErrorCode["AgentInstanceNotFound"] = "AGENT_INSTANCE_NOT_FOUND";
    ApiErrorCode["InvalidJsonSchema"] = "INVALID_JSON_SCHEMA";
    ApiErrorCode["ToolNotFound"] = "TOOL_NOT_FOUND";
    ApiErrorCode["InvalidJson"] = "INVALID_JSON";
    ApiErrorCode["InvalidOauth2State"] = "INVALID_OAUTH2_STATE";
    ApiErrorCode["DeploymentNotFound"] = "DEPLOYMENT_NOT_FOUND";
    ApiErrorCode["BotConfigNotFound"] = "BOT_CONFIG_NOT_FOUND";
    ApiErrorCode["DeploymentNotDraft"] = "DEPLOYMENT_NOT_DRAFT";
    ApiErrorCode["BlobPermissionDenied"] = "BLOB_PERMISSION_DENIED";
    ApiErrorCode["AgentInstNotFound"] = "AGENT_INST_NOT_FOUND";
    ApiErrorCode["DraftNotFound"] = "DRAFT_NOT_FOUND";
    ApiErrorCode["ToolTagDuplicated"] = "TOOL_TAG_DUPLICATED";
    ApiErrorCode["Oauth2ProviderNameDuplicated"] = "OAUTH2_PROVIDER_NAME_DUPLICATED";
    ApiErrorCode["BotTypeNotSupported"] = "BOT_TYPE_NOT_SUPPORTED";
    ApiErrorCode["BotConfigRequired"] = "BOT_CONFIG_REQUIRED";
    ApiErrorCode["InvalidOwnerType"] = "INVALID_OWNER_TYPE";
    ApiErrorCode["ToolReleaseNotFound"] = "TOOL_RELEASE_NOT_FOUND";
    ApiErrorCode["InvalidSlackWebhookSignature"] = "INVALID_SLACK_WEBHOOK_SIGNATURE";
    ApiErrorCode["ContextOutdated"] = "CONTEXT_OUTDATED";
    ApiErrorCode["ContextNotFound"] = "CONTEXT_NOT_FOUND";
    ApiErrorCode["DraftToolReleaseNotAllowed"] = "DRAFT_TOOL_RELEASE_NOT_ALLOWED";
    ApiErrorCode["ToolReleaseDuplicated"] = "TOOL_RELEASE_DUPLICATED";
    ApiErrorCode["ToolNameOrPromptNameAlreadyExists"] = "TOOL_NAME_OR_PROMPT_NAME_ALREADY_EXISTS";
    ApiErrorCode["ProjectNotFound"] = "PROJECT_NOT_FOUND";
    ApiErrorCode["Oauth2ProviderNotFound"] = "OAUTH2_PROVIDER_NOT_FOUND";
    ApiErrorCode["InvalidApiToken"] = "INVALID_API_TOKEN";
    ApiErrorCode["AgentAlreadyLiked"] = "AGENT_ALREADY_LIKED";
    ApiErrorCode["AgentNotLiked"] = "AGENT_NOT_LIKED";
    ApiErrorCode["AgentNameError"] = "AGENT_NAME_ERROR";
    ApiErrorCode["AgentInstVersionError"] = "AGENT_INST_VERSION_ERROR";
    ApiErrorCode["DraftCannotBeUpdated"] = "DRAFT_CANNOT_BE_UPDATED";
    ApiErrorCode["InvalidOwnerUserId"] = "INVALID_OWNER_USER_ID";
    ApiErrorCode["InvalidOwnerTeamId"] = "INVALID_OWNER_TEAM_ID";
    ApiErrorCode["FetchScheduleNotFound"] = "FETCH_SCHEDULE_NOT_FOUND";
    ApiErrorCode["ProjectOwnerTypeNotFound"] = "PROJECT_OWNER_TYPE_NOT_FOUND";
    ApiErrorCode["AgentProjectNotFound"] = "AGENT_PROJECT_NOT_FOUND";
    ApiErrorCode["BotProjectNotFound"] = "BOT_PROJECT_NOT_FOUND";
    ApiErrorCode["ChannelNotFound"] = "CHANNEL_NOT_FOUND";
    ApiErrorCode["ChannelProjectNotFound"] = "CHANNEL_PROJECT_NOT_FOUND";
    ApiErrorCode["DeploymentProjectNotFound"] = "DEPLOYMENT_PROJECT_NOT_FOUND";
    ApiErrorCode["EnvProjectNotFound"] = "ENV_PROJECT_NOT_FOUND";
    ApiErrorCode["LoaderNameAlreadyExists"] = "LOADER_NAME_ALREADY_EXISTS";
    ApiErrorCode["LoaderNotFound"] = "LOADER_NOT_FOUND";
    ApiErrorCode["LoaderReleaseNotFound"] = "LOADER_RELEASE_NOT_FOUND";
    ApiErrorCode["LoaderReleaseDuplicated"] = "LOADER_RELEASE_DUPLICATED";
    ApiErrorCode["LoaderReleaseIsUsed"] = "LOADER_RELEASE_IS_USED";
    ApiErrorCode["KnwlBaseNotFound"] = "KNWL_BASE_NOT_FOUND";
    ApiErrorCode["DraftAgentInstNotFound"] = "DRAFT_AGENT_INST_NOT_FOUND";
    ApiErrorCode["KnowledgeNotFound"] = "KNOWLEDGE_NOT_FOUND";
    ApiErrorCode["KnwlBaseInUse"] = "KNWL_BASE_IN_USE";
    ApiErrorCode["ToolInUse"] = "TOOL_IN_USE";
    ApiErrorCode["ToolReleaseInUse"] = "TOOL_RELEASE_IN_USE";
    ApiErrorCode["LoaderReleaseInUse"] = "LOADER_RELEASE_IN_USE";
    ApiErrorCode["LoaderInUse"] = "LOADER_IN_USE";
    ApiErrorCode["AgentInstanceIsDeployed"] = "AGENT_INSTANCE_IS_DEPLOYED";
    ApiErrorCode["EnvHasDeployment"] = "ENV_HAS_DEPLOYMENT";
    ApiErrorCode["InvalidOpenApiKey"] = "INVALID_OPEN_API_KEY";
    ApiErrorCode["OpenApiKeyQuotaExceeded"] = "OPEN_API_KEY_QUOTA_EXCEEDED";
    ApiErrorCode["UnknownOpenApiKeyError"] = "UNKNOWN_OPEN_API_KEY_ERROR";
    ApiErrorCode["TeamHasProjects"] = "TEAM_HAS_PROJECTS";
    ApiErrorCode["TeamHasMembers"] = "TEAM_HAS_MEMBERS";
    ApiErrorCode["KnwlProjectNotFound"] = "KNWL_PROJECT_NOT_FOUND";
    ApiErrorCode["ProjectTeamNotFound"] = "PROJECT_TEAM_NOT_FOUND";
    ApiErrorCode["AgentAndAgentInstNotMatch"] = "AGENT_AND_AGENT_INST_NOT_MATCH";
    ApiErrorCode["EnvAndEnvVarNotMatch"] = "ENV_AND_ENV_VAR_NOT_MATCH";
    ApiErrorCode["FetchNotFound"] = "FETCH_NOT_FOUND";
})(ApiErrorCode = exports.ApiErrorCode || (exports.ApiErrorCode = {}));
/**
    * @export
    * @enum {string}
    */
var BotCreationBotTypeEnum;
(function (BotCreationBotTypeEnum) {
    BotCreationBotTypeEnum["Generics"] = "GENERICS";
    BotCreationBotTypeEnum["Telegram"] = "TELEGRAM";
    BotCreationBotTypeEnum["Slack"] = "SLACK";
})(BotCreationBotTypeEnum = exports.BotCreationBotTypeEnum || (exports.BotCreationBotTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var BotDtoBotTypeEnum;
(function (BotDtoBotTypeEnum) {
    BotDtoBotTypeEnum["Generics"] = "GENERICS";
    BotDtoBotTypeEnum["Telegram"] = "TELEGRAM";
    BotDtoBotTypeEnum["Slack"] = "SLACK";
})(BotDtoBotTypeEnum = exports.BotDtoBotTypeEnum || (exports.BotDtoBotTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var BriefEnvCoreVersionIdEnum;
(function (BriefEnvCoreVersionIdEnum) {
    BriefEnvCoreVersionIdEnum["Gpt4230701"] = "V_GPT4_230701";
    BriefEnvCoreVersionIdEnum["Gpt432K230701"] = "V_GPT4_32K_230701";
    BriefEnvCoreVersionIdEnum["Gpt35230701"] = "V_GPT35_230701";
    BriefEnvCoreVersionIdEnum["Gpt3516K230701"] = "V_GPT35_16K_230701";
    BriefEnvCoreVersionIdEnum["Aoai"] = "V_AOAI";
})(BriefEnvCoreVersionIdEnum = exports.BriefEnvCoreVersionIdEnum || (exports.BriefEnvCoreVersionIdEnum = {}));
/**
    * @export
    * @enum {string}
    */
var BriefTeamMemberDtoRoleEnum;
(function (BriefTeamMemberDtoRoleEnum) {
    BriefTeamMemberDtoRoleEnum["None"] = "NONE";
    BriefTeamMemberDtoRoleEnum["Admin"] = "ADMIN";
})(BriefTeamMemberDtoRoleEnum = exports.BriefTeamMemberDtoRoleEnum || (exports.BriefTeamMemberDtoRoleEnum = {}));
/**
    * @export
    * @enum {string}
    */
var BriefToolOwnerTypeEnum;
(function (BriefToolOwnerTypeEnum) {
    BriefToolOwnerTypeEnum["User"] = "USER";
    BriefToolOwnerTypeEnum["Team"] = "TEAM";
})(BriefToolOwnerTypeEnum = exports.BriefToolOwnerTypeEnum || (exports.BriefToolOwnerTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CommandConfirmModeEnum;
(function (CommandConfirmModeEnum) {
    CommandConfirmModeEnum["Always"] = "ALWAYS";
    CommandConfirmModeEnum["Ask"] = "ASK";
    CommandConfirmModeEnum["Notify"] = "NOTIFY";
    CommandConfirmModeEnum["Never"] = "NEVER";
})(CommandConfirmModeEnum = exports.CommandConfirmModeEnum || (exports.CommandConfirmModeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CommandDtoConfirmModeEnum;
(function (CommandDtoConfirmModeEnum) {
    CommandDtoConfirmModeEnum["Always"] = "ALWAYS";
    CommandDtoConfirmModeEnum["Ask"] = "ASK";
    CommandDtoConfirmModeEnum["Notify"] = "NOTIFY";
    CommandDtoConfirmModeEnum["Never"] = "NEVER";
})(CommandDtoConfirmModeEnum = exports.CommandDtoConfirmModeEnum || (exports.CommandDtoConfirmModeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DeploymentDtoStatusEnum;
(function (DeploymentDtoStatusEnum) {
    DeploymentDtoStatusEnum["Deploying"] = "DEPLOYING";
    DeploymentDtoStatusEnum["Deployed"] = "DEPLOYED";
    DeploymentDtoStatusEnum["Failed"] = "FAILED";
})(DeploymentDtoStatusEnum = exports.DeploymentDtoStatusEnum || (exports.DeploymentDtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DraftEnvCoreVersionIdEnum;
(function (DraftEnvCoreVersionIdEnum) {
    DraftEnvCoreVersionIdEnum["Gpt4230701"] = "V_GPT4_230701";
    DraftEnvCoreVersionIdEnum["Gpt432K230701"] = "V_GPT4_32K_230701";
    DraftEnvCoreVersionIdEnum["Gpt35230701"] = "V_GPT35_230701";
    DraftEnvCoreVersionIdEnum["Gpt3516K230701"] = "V_GPT35_16K_230701";
    DraftEnvCoreVersionIdEnum["Aoai"] = "V_AOAI";
})(DraftEnvCoreVersionIdEnum = exports.DraftEnvCoreVersionIdEnum || (exports.DraftEnvCoreVersionIdEnum = {}));
/**
    * @export
    * @enum {string}
    */
var EnvCreationCoreVersionIdEnum;
(function (EnvCreationCoreVersionIdEnum) {
    EnvCreationCoreVersionIdEnum["Gpt4230701"] = "V_GPT4_230701";
    EnvCreationCoreVersionIdEnum["Gpt432K230701"] = "V_GPT4_32K_230701";
    EnvCreationCoreVersionIdEnum["Gpt35230701"] = "V_GPT35_230701";
    EnvCreationCoreVersionIdEnum["Gpt3516K230701"] = "V_GPT35_16K_230701";
    EnvCreationCoreVersionIdEnum["Aoai"] = "V_AOAI";
})(EnvCreationCoreVersionIdEnum = exports.EnvCreationCoreVersionIdEnum || (exports.EnvCreationCoreVersionIdEnum = {}));
/**
    * @export
    * @enum {string}
    */
var EnvDtoCoreVersionIdEnum;
(function (EnvDtoCoreVersionIdEnum) {
    EnvDtoCoreVersionIdEnum["Gpt4230701"] = "V_GPT4_230701";
    EnvDtoCoreVersionIdEnum["Gpt432K230701"] = "V_GPT4_32K_230701";
    EnvDtoCoreVersionIdEnum["Gpt35230701"] = "V_GPT35_230701";
    EnvDtoCoreVersionIdEnum["Gpt3516K230701"] = "V_GPT35_16K_230701";
    EnvDtoCoreVersionIdEnum["Aoai"] = "V_AOAI";
})(EnvDtoCoreVersionIdEnum = exports.EnvDtoCoreVersionIdEnum || (exports.EnvDtoCoreVersionIdEnum = {}));
/**
    * @export
    * @enum {string}
    */
var EnvUpdateCoreVersionIdEnum;
(function (EnvUpdateCoreVersionIdEnum) {
    EnvUpdateCoreVersionIdEnum["Gpt4230701"] = "V_GPT4_230701";
    EnvUpdateCoreVersionIdEnum["Gpt432K230701"] = "V_GPT4_32K_230701";
    EnvUpdateCoreVersionIdEnum["Gpt35230701"] = "V_GPT35_230701";
    EnvUpdateCoreVersionIdEnum["Gpt3516K230701"] = "V_GPT35_16K_230701";
    EnvUpdateCoreVersionIdEnum["Aoai"] = "V_AOAI";
})(EnvUpdateCoreVersionIdEnum = exports.EnvUpdateCoreVersionIdEnum || (exports.EnvUpdateCoreVersionIdEnum = {}));
/**
    * @export
    * @enum {string}
    */
var FetchDtoStatusEnum;
(function (FetchDtoStatusEnum) {
    FetchDtoStatusEnum["Pending"] = "PENDING";
    FetchDtoStatusEnum["Ready"] = "READY";
    FetchDtoStatusEnum["Receiving"] = "RECEIVING";
    FetchDtoStatusEnum["Closed"] = "CLOSED";
    FetchDtoStatusEnum["Expired"] = "EXPIRED";
    FetchDtoStatusEnum["Failed"] = "FAILED";
})(FetchDtoStatusEnum = exports.FetchDtoStatusEnum || (exports.FetchDtoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var FetchEventDtoLevelEnum;
(function (FetchEventDtoLevelEnum) {
    FetchEventDtoLevelEnum["Info"] = "INFO";
    FetchEventDtoLevelEnum["Warn"] = "WARN";
    FetchEventDtoLevelEnum["Error"] = "ERROR";
})(FetchEventDtoLevelEnum = exports.FetchEventDtoLevelEnum || (exports.FetchEventDtoLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var JsonNodeNodeTypeEnum;
(function (JsonNodeNodeTypeEnum) {
    JsonNodeNodeTypeEnum["Array"] = "ARRAY";
    JsonNodeNodeTypeEnum["Binary"] = "BINARY";
    JsonNodeNodeTypeEnum["Boolean"] = "BOOLEAN";
    JsonNodeNodeTypeEnum["Missing"] = "MISSING";
    JsonNodeNodeTypeEnum["Null"] = "NULL";
    JsonNodeNodeTypeEnum["Number"] = "NUMBER";
    JsonNodeNodeTypeEnum["Object"] = "OBJECT";
    JsonNodeNodeTypeEnum["Pojo"] = "POJO";
    JsonNodeNodeTypeEnum["String"] = "STRING";
})(JsonNodeNodeTypeEnum = exports.JsonNodeNodeTypeEnum || (exports.JsonNodeNodeTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var LoaderCreationOwnerTypeEnum;
(function (LoaderCreationOwnerTypeEnum) {
    LoaderCreationOwnerTypeEnum["User"] = "USER";
    LoaderCreationOwnerTypeEnum["Team"] = "TEAM";
})(LoaderCreationOwnerTypeEnum = exports.LoaderCreationOwnerTypeEnum || (exports.LoaderCreationOwnerTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var LoaderCreationVisibilityEnum;
(function (LoaderCreationVisibilityEnum) {
    LoaderCreationVisibilityEnum["Private"] = "PRIVATE";
    LoaderCreationVisibilityEnum["Public"] = "PUBLIC";
})(LoaderCreationVisibilityEnum = exports.LoaderCreationVisibilityEnum || (exports.LoaderCreationVisibilityEnum = {}));
/**
    * @export
    * @enum {string}
    */
var LoaderDeleteCallbackBodyModeEnum;
(function (LoaderDeleteCallbackBodyModeEnum) {
    LoaderDeleteCallbackBodyModeEnum["DeletedIdList"] = "DELETED_ID_LIST";
    LoaderDeleteCallbackBodyModeEnum["PreservedIdList"] = "PRESERVED_ID_LIST";
})(LoaderDeleteCallbackBodyModeEnum = exports.LoaderDeleteCallbackBodyModeEnum || (exports.LoaderDeleteCallbackBodyModeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var LoaderDtoOwnerTypeEnum;
(function (LoaderDtoOwnerTypeEnum) {
    LoaderDtoOwnerTypeEnum["User"] = "USER";
    LoaderDtoOwnerTypeEnum["Team"] = "TEAM";
})(LoaderDtoOwnerTypeEnum = exports.LoaderDtoOwnerTypeEnum || (exports.LoaderDtoOwnerTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var LoaderDtoVisibilityEnum;
(function (LoaderDtoVisibilityEnum) {
    LoaderDtoVisibilityEnum["Private"] = "PRIVATE";
    LoaderDtoVisibilityEnum["Public"] = "PUBLIC";
})(LoaderDtoVisibilityEnum = exports.LoaderDtoVisibilityEnum || (exports.LoaderDtoVisibilityEnum = {}));
/**
    * @export
    * @enum {string}
    */
var LoaderUpdatesVisibilityEnum;
(function (LoaderUpdatesVisibilityEnum) {
    LoaderUpdatesVisibilityEnum["Private"] = "PRIVATE";
    LoaderUpdatesVisibilityEnum["Public"] = "PUBLIC";
})(LoaderUpdatesVisibilityEnum = exports.LoaderUpdatesVisibilityEnum || (exports.LoaderUpdatesVisibilityEnum = {}));
/**
    * @export
    * @enum {string}
    */
var OAuth2ProviderGrantTypeEnum;
(function (OAuth2ProviderGrantTypeEnum) {
    OAuth2ProviderGrantTypeEnum["AuthorizationCode"] = "AUTHORIZATION_CODE";
})(OAuth2ProviderGrantTypeEnum = exports.OAuth2ProviderGrantTypeEnum || (exports.OAuth2ProviderGrantTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var Oauth2ProviderDtoGrantTypeEnum;
(function (Oauth2ProviderDtoGrantTypeEnum) {
    Oauth2ProviderDtoGrantTypeEnum["AuthorizationCode"] = "AUTHORIZATION_CODE";
})(Oauth2ProviderDtoGrantTypeEnum = exports.Oauth2ProviderDtoGrantTypeEnum || (exports.Oauth2ProviderDtoGrantTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ProjectCreationOwnerTypeEnum;
(function (ProjectCreationOwnerTypeEnum) {
    ProjectCreationOwnerTypeEnum["User"] = "USER";
    ProjectCreationOwnerTypeEnum["Team"] = "TEAM";
})(ProjectCreationOwnerTypeEnum = exports.ProjectCreationOwnerTypeEnum || (exports.ProjectCreationOwnerTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ProjectDtoOwnerTypeEnum;
(function (ProjectDtoOwnerTypeEnum) {
    ProjectDtoOwnerTypeEnum["User"] = "USER";
    ProjectDtoOwnerTypeEnum["Team"] = "TEAM";
})(ProjectDtoOwnerTypeEnum = exports.ProjectDtoOwnerTypeEnum || (exports.ProjectDtoOwnerTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var SlackEventTypeEnum;
(function (SlackEventTypeEnum) {
    SlackEventTypeEnum["Message"] = "message";
})(SlackEventTypeEnum = exports.SlackEventTypeEnum || (exports.SlackEventTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var SlackEventSubtypeEnum;
(function (SlackEventSubtypeEnum) {
    SlackEventSubtypeEnum["BotMessage"] = "bot_message";
    SlackEventSubtypeEnum["MeMessage"] = "me_message";
    SlackEventSubtypeEnum["MessageChanged"] = "message_changed";
    SlackEventSubtypeEnum["MessageDeleted"] = "message_deleted";
    SlackEventSubtypeEnum["MessageReplied"] = "message_replied";
    SlackEventSubtypeEnum["ThreadBroadcast"] = "thread_broadcast";
    SlackEventSubtypeEnum["ChannelJoin"] = "channel_join";
    SlackEventSubtypeEnum["ChannelLeave"] = "channel_leave";
    SlackEventSubtypeEnum["ChannelTopic"] = "channel_topic";
    SlackEventSubtypeEnum["ChannelPurpose"] = "channel_purpose";
    SlackEventSubtypeEnum["ChannelName"] = "channel_name";
    SlackEventSubtypeEnum["ChannelArchive"] = "channel_archive";
    SlackEventSubtypeEnum["ChannelUnarchive"] = "channel_unarchive";
    SlackEventSubtypeEnum["FileShare"] = "file_share";
})(SlackEventSubtypeEnum = exports.SlackEventSubtypeEnum || (exports.SlackEventSubtypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var SlackEventWrapperTypeEnum;
(function (SlackEventWrapperTypeEnum) {
    SlackEventWrapperTypeEnum["UrlVerification"] = "url_verification";
    SlackEventWrapperTypeEnum["EventCallback"] = "event_callback";
})(SlackEventWrapperTypeEnum = exports.SlackEventWrapperTypeEnum || (exports.SlackEventWrapperTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var TagDtoDomainEnum;
(function (TagDtoDomainEnum) {
    TagDtoDomainEnum["ToolCategory"] = "TOOL_CATEGORY";
    TagDtoDomainEnum["LoaderCategory"] = "LOADER_CATEGORY";
})(TagDtoDomainEnum = exports.TagDtoDomainEnum || (exports.TagDtoDomainEnum = {}));
/**
    * @export
    * @enum {string}
    */
var TeamMemberDtoRoleEnum;
(function (TeamMemberDtoRoleEnum) {
    TeamMemberDtoRoleEnum["None"] = "NONE";
    TeamMemberDtoRoleEnum["Admin"] = "ADMIN";
})(TeamMemberDtoRoleEnum = exports.TeamMemberDtoRoleEnum || (exports.TeamMemberDtoRoleEnum = {}));
/**
    * @export
    * @enum {string}
    */
var TeamMemberUpdateRoleEnum;
(function (TeamMemberUpdateRoleEnum) {
    TeamMemberUpdateRoleEnum["None"] = "NONE";
    TeamMemberUpdateRoleEnum["Admin"] = "ADMIN";
})(TeamMemberUpdateRoleEnum = exports.TeamMemberUpdateRoleEnum || (exports.TeamMemberUpdateRoleEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ToolCreationVisibilityEnum;
(function (ToolCreationVisibilityEnum) {
    ToolCreationVisibilityEnum["Private"] = "PRIVATE";
    ToolCreationVisibilityEnum["Public"] = "PUBLIC";
})(ToolCreationVisibilityEnum = exports.ToolCreationVisibilityEnum || (exports.ToolCreationVisibilityEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ToolCreationOwnerTypeEnum;
(function (ToolCreationOwnerTypeEnum) {
    ToolCreationOwnerTypeEnum["User"] = "USER";
    ToolCreationOwnerTypeEnum["Team"] = "TEAM";
})(ToolCreationOwnerTypeEnum = exports.ToolCreationOwnerTypeEnum || (exports.ToolCreationOwnerTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ToolDtoOwnerTypeEnum;
(function (ToolDtoOwnerTypeEnum) {
    ToolDtoOwnerTypeEnum["User"] = "USER";
    ToolDtoOwnerTypeEnum["Team"] = "TEAM";
})(ToolDtoOwnerTypeEnum = exports.ToolDtoOwnerTypeEnum || (exports.ToolDtoOwnerTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ToolUpdatesVisibilityEnum;
(function (ToolUpdatesVisibilityEnum) {
    ToolUpdatesVisibilityEnum["Private"] = "PRIVATE";
    ToolUpdatesVisibilityEnum["Public"] = "PUBLIC";
})(ToolUpdatesVisibilityEnum = exports.ToolUpdatesVisibilityEnum || (exports.ToolUpdatesVisibilityEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UserMessageActionEnum;
(function (UserMessageActionEnum) {
    UserMessageActionEnum["ConfirmAccept"] = "CONFIRM_ACCEPT";
    UserMessageActionEnum["ConfirmDeny"] = "CONFIRM_DENY";
    UserMessageActionEnum["ResetChannel"] = "RESET_CHANNEL";
})(UserMessageActionEnum = exports.UserMessageActionEnum || (exports.UserMessageActionEnum = {}));
/**
    * @export
    * @enum {string}
    */
var UserPositionUpsertJobPositionEnum;
(function (UserPositionUpsertJobPositionEnum) {
    UserPositionUpsertJobPositionEnum["CeoFounder"] = "CEO_FOUNDER";
    UserPositionUpsertJobPositionEnum["CtoTechnicalLead"] = "CTO_TECHNICAL_LEAD";
    UserPositionUpsertJobPositionEnum["Marketing"] = "MARKETING";
    UserPositionUpsertJobPositionEnum["Sales"] = "SALES";
    UserPositionUpsertJobPositionEnum["ProductManager"] = "PRODUCT_MANAGER";
    UserPositionUpsertJobPositionEnum["Designer"] = "DESIGNER";
    UserPositionUpsertJobPositionEnum["EngineerDeveloper"] = "ENGINEER_DEVELOPER";
    UserPositionUpsertJobPositionEnum["CustomerSupport"] = "CUSTOMER_SUPPORT";
    UserPositionUpsertJobPositionEnum["DataAnalystScientist"] = "DATA_ANALYST_SCIENTIST";
    UserPositionUpsertJobPositionEnum["HrRecruiter"] = "HR_RECRUITER";
    UserPositionUpsertJobPositionEnum["FinancialAccounting"] = "FINANCIAL_ACCOUNTING";
    UserPositionUpsertJobPositionEnum["Operations"] = "OPERATIONS";
    UserPositionUpsertJobPositionEnum["TeacherProfessor"] = "TEACHER_PROFESSOR";
    UserPositionUpsertJobPositionEnum["LawyerAttorney"] = "LAWYER_ATTORNEY";
    UserPositionUpsertJobPositionEnum["Policy"] = "POLICY";
    UserPositionUpsertJobPositionEnum["Student"] = "STUDENT";
    UserPositionUpsertJobPositionEnum["Other"] = "OTHER";
})(UserPositionUpsertJobPositionEnum = exports.UserPositionUpsertJobPositionEnum || (exports.UserPositionUpsertJobPositionEnum = {}));
/**
 * AgentApi - axios parameter creator
 * @export
 */
exports.AgentApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create an agent
         * @param {AgentCreation} agentCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgent: function (agentCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'agentCreation' is not null or undefined
                            common_1.assertParamExists('createAgent', 'agentCreation', agentCreation);
                            localVarPath = "/api/agent";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(agentCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create an instance of an agent
         * @param {string} id
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentInstance: function (id, version, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('createAgentInstance', 'id', id);
                            // verify required parameter 'version' is not null or undefined
                            common_1.assertParamExists('createAgentInstance', 'version', version);
                            localVarPath = "/api/agent/{id}/inst/{version}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)))
                                .replace("{" + "version" + "}", encodeURIComponent(String(version)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create or update a skill for a draft agent instance
         * @param {string} id
         * @param {string} toolId
         * @param {string} toolReleaseVersion
         * @param {SkillUpsert} skillUpsert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftAgentInstanceSkill: function (id, toolId, toolReleaseVersion, skillUpsert, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('createDraftAgentInstanceSkill', 'id', id);
                            // verify required parameter 'toolId' is not null or undefined
                            common_1.assertParamExists('createDraftAgentInstanceSkill', 'toolId', toolId);
                            // verify required parameter 'toolReleaseVersion' is not null or undefined
                            common_1.assertParamExists('createDraftAgentInstanceSkill', 'toolReleaseVersion', toolReleaseVersion);
                            // verify required parameter 'skillUpsert' is not null or undefined
                            common_1.assertParamExists('createDraftAgentInstanceSkill', 'skillUpsert', skillUpsert);
                            localVarPath = "/api/agent/{id}/inst/draft/skill/{toolId}/release/{toolReleaseVersion}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)))
                                .replace("{" + "toolId" + "}", encodeURIComponent(String(toolId)))
                                .replace("{" + "toolReleaseVersion" + "}", encodeURIComponent(String(toolReleaseVersion)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(skillUpsert, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a agent
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgent: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('deleteAgent', 'id', id);
                            localVarPath = "/api/agent/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a agent instance by version, except draft version
         * @param {string} id
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentInstanceByVersion: function (id, version, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('deleteAgentInstanceByVersion', 'id', id);
                            // verify required parameter 'version' is not null or undefined
                            common_1.assertParamExists('deleteAgentInstanceByVersion', 'version', version);
                            localVarPath = "/api/agent/{id}/inst/{version}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)))
                                .replace("{" + "version" + "}", encodeURIComponent(String(version)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete knowledge for a draft agent instance
         * @param {string} id
         * @param {string} knwlBaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDraftAgentInstanceKnowledge: function (id, knwlBaseId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('deleteDraftAgentInstanceKnowledge', 'id', id);
                            // verify required parameter 'knwlBaseId' is not null or undefined
                            common_1.assertParamExists('deleteDraftAgentInstanceKnowledge', 'knwlBaseId', knwlBaseId);
                            localVarPath = "/api/agent/{id}/inst/draft/knwl-base/{knwlBaseId}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)))
                                .replace("{" + "knwlBaseId" + "}", encodeURIComponent(String(knwlBaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a skill for a draft agent instance
         * @param {string} id
         * @param {string} toolId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDraftAgentInstanceSkill: function (id, toolId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('deleteDraftAgentInstanceSkill', 'id', id);
                            // verify required parameter 'toolId' is not null or undefined
                            common_1.assertParamExists('deleteDraftAgentInstanceSkill', 'toolId', toolId);
                            localVarPath = "/api/agent/{id}/inst/draft/skill/{toolId}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)))
                                .replace("{" + "toolId" + "}", encodeURIComponent(String(toolId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get an agent by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentById: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getAgentById', 'id', id);
                            localVarPath = "/api/agent/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all deployments of an agent
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentDeployment: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getAgentDeployment', 'id', id);
                            localVarPath = "/api/agent/{id}/deployment"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get agent instance by version
         * @param {string} id
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentInstanceById: function (id, version, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getAgentInstanceById', 'id', id);
                            // verify required parameter 'version' is not null or undefined
                            common_1.assertParamExists('getAgentInstanceById', 'version', version);
                            localVarPath = "/api/agent/{id}/inst/{version}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)))
                                .replace("{" + "version" + "}", encodeURIComponent(String(version)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all instance of an agent
         * @param {string} id
         * @param {boolean} includeDraft
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentInstances: function (id, includeDraft, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getAgentInstances', 'id', id);
                            // verify required parameter 'includeDraft' is not null or undefined
                            common_1.assertParamExists('getAgentInstances', 'includeDraft', includeDraft);
                            localVarPath = "/api/agent/{id}/inst"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (includeDraft !== undefined) {
                                localVarQueryParameter['includeDraft'] = includeDraft;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all available knowledge base of a draft agent instance
         * @param {string} id
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {string} [keyword] Keyword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftAgentInstanceAvailKnwlBase: function (id, page, size, keyword, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getDraftAgentInstanceAvailKnwlBase', 'id', id);
                            // verify required parameter 'page' is not null or undefined
                            common_1.assertParamExists('getDraftAgentInstanceAvailKnwlBase', 'page', page);
                            // verify required parameter 'size' is not null or undefined
                            common_1.assertParamExists('getDraftAgentInstanceAvailKnwlBase', 'size', size);
                            localVarPath = "/api/agent/{id}/inst/draft/avail-knwl-base"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (keyword !== undefined) {
                                localVarQueryParameter['keyword'] = keyword;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all available tool release of a draft agent instance
         * @param {string} id
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {string} [keyword] Keyword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftAgentInstanceAvailToolReleases: function (id, page, size, keyword, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getDraftAgentInstanceAvailToolReleases', 'id', id);
                            // verify required parameter 'page' is not null or undefined
                            common_1.assertParamExists('getDraftAgentInstanceAvailToolReleases', 'page', page);
                            // verify required parameter 'size' is not null or undefined
                            common_1.assertParamExists('getDraftAgentInstanceAvailToolReleases', 'size', size);
                            localVarPath = "/api/agent/{id}/inst/draft/avail-tool-release"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (keyword !== undefined) {
                                localVarQueryParameter['keyword'] = keyword;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all knowledge of draft agent instance
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftAgentInstanceKnowledge: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getDraftAgentInstanceKnowledge', 'id', id);
                            localVarPath = "/api/agent/{id}/inst/draft/knwl"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all skills of draft agent instance
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftAgentInstanceSkills: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getDraftAgentInstanceSkills', 'id', id);
                            localVarPath = "/api/agent/{id}/inst/draft/skill"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Enable a draft agent instance greeting text
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleDraftAgentInstanceGreetingEnabled: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('toggleDraftAgentInstanceGreetingEnabled', 'id', id);
                            localVarPath = "/api/agent/{id}/inst/draft/toggle-greeting"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Enable/disable a skill for a draft agent instance
         * @param {string} id
         * @param {string} toolId
         * @param {string} toolReleaseVersion
         * @param {ToggleSkillEnabled} toggleSkillEnabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleDraftAgentInstanceSkillEnabled: function (id, toolId, toolReleaseVersion, toggleSkillEnabled, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('toggleDraftAgentInstanceSkillEnabled', 'id', id);
                            // verify required parameter 'toolId' is not null or undefined
                            common_1.assertParamExists('toggleDraftAgentInstanceSkillEnabled', 'toolId', toolId);
                            // verify required parameter 'toolReleaseVersion' is not null or undefined
                            common_1.assertParamExists('toggleDraftAgentInstanceSkillEnabled', 'toolReleaseVersion', toolReleaseVersion);
                            // verify required parameter 'toggleSkillEnabled' is not null or undefined
                            common_1.assertParamExists('toggleDraftAgentInstanceSkillEnabled', 'toggleSkillEnabled', toggleSkillEnabled);
                            localVarPath = "/api/agent/{id}/inst/draft/skill/{toolId}/release/{toolReleaseVersion}/toggle-enable"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)))
                                .replace("{" + "toolId" + "}", encodeURIComponent(String(toolId)))
                                .replace("{" + "toolReleaseVersion" + "}", encodeURIComponent(String(toolReleaseVersion)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(toggleSkillEnabled, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a agent
         * @param {string} id
         * @param {AgentUpdate} agentUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgent: function (id, agentUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('updateAgent', 'id', id);
                            // verify required parameter 'agentUpdate' is not null or undefined
                            common_1.assertParamExists('updateAgent', 'agentUpdate', agentUpdate);
                            localVarPath = "/api/agent/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(agentUpdate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a draft agent instance
         * @param {string} id
         * @param {AgentInstUpdate} agentInstUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraftAgentInstance: function (id, agentInstUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('updateDraftAgentInstance', 'id', id);
                            // verify required parameter 'agentInstUpdate' is not null or undefined
                            common_1.assertParamExists('updateDraftAgentInstance', 'agentInstUpdate', agentInstUpdate);
                            localVarPath = "/api/agent/{id}/inst/draft"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(agentInstUpdate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create or update knowledge of a draft agent instance
         * @param {string} id
         * @param {string} knwlBaseId
         * @param {KnowledgeUpsert} knowledgeUpsert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertDraftAgentInstanceKnowledge: function (id, knwlBaseId, knowledgeUpsert, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('upsertDraftAgentInstanceKnowledge', 'id', id);
                            // verify required parameter 'knwlBaseId' is not null or undefined
                            common_1.assertParamExists('upsertDraftAgentInstanceKnowledge', 'knwlBaseId', knwlBaseId);
                            // verify required parameter 'knowledgeUpsert' is not null or undefined
                            common_1.assertParamExists('upsertDraftAgentInstanceKnowledge', 'knowledgeUpsert', knowledgeUpsert);
                            localVarPath = "/api/agent/{id}/inst/draft/knwl-base/{knwlBaseId}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)))
                                .replace("{" + "knwlBaseId" + "}", encodeURIComponent(String(knwlBaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(knowledgeUpsert, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * AgentApi - functional programming interface
 * @export
 */
exports.AgentApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.AgentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create an agent
         * @param {AgentCreation} agentCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgent: function (agentCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAgent(agentCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create an instance of an agent
         * @param {string} id
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentInstance: function (id, version, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAgentInstance(id, version, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create or update a skill for a draft agent instance
         * @param {string} id
         * @param {string} toolId
         * @param {string} toolReleaseVersion
         * @param {SkillUpsert} skillUpsert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftAgentInstanceSkill: function (id, toolId, toolReleaseVersion, skillUpsert, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDraftAgentInstanceSkill(id, toolId, toolReleaseVersion, skillUpsert, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a agent
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgent: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteAgent(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a agent instance by version, except draft version
         * @param {string} id
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentInstanceByVersion: function (id, version, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteAgentInstanceByVersion(id, version, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete knowledge for a draft agent instance
         * @param {string} id
         * @param {string} knwlBaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDraftAgentInstanceKnowledge: function (id, knwlBaseId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDraftAgentInstanceKnowledge(id, knwlBaseId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a skill for a draft agent instance
         * @param {string} id
         * @param {string} toolId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDraftAgentInstanceSkill: function (id, toolId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDraftAgentInstanceSkill(id, toolId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get an agent by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentById: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAgentById(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all deployments of an agent
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentDeployment: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAgentDeployment(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get agent instance by version
         * @param {string} id
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentInstanceById: function (id, version, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAgentInstanceById(id, version, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all instance of an agent
         * @param {string} id
         * @param {boolean} includeDraft
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentInstances: function (id, includeDraft, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAgentInstances(id, includeDraft, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all available knowledge base of a draft agent instance
         * @param {string} id
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {string} [keyword] Keyword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftAgentInstanceAvailKnwlBase: function (id, page, size, keyword, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDraftAgentInstanceAvailKnwlBase(id, page, size, keyword, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all available tool release of a draft agent instance
         * @param {string} id
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {string} [keyword] Keyword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftAgentInstanceAvailToolReleases: function (id, page, size, keyword, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDraftAgentInstanceAvailToolReleases(id, page, size, keyword, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all knowledge of draft agent instance
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftAgentInstanceKnowledge: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDraftAgentInstanceKnowledge(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all skills of draft agent instance
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftAgentInstanceSkills: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDraftAgentInstanceSkills(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Enable a draft agent instance greeting text
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleDraftAgentInstanceGreetingEnabled: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.toggleDraftAgentInstanceGreetingEnabled(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Enable/disable a skill for a draft agent instance
         * @param {string} id
         * @param {string} toolId
         * @param {string} toolReleaseVersion
         * @param {ToggleSkillEnabled} toggleSkillEnabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleDraftAgentInstanceSkillEnabled: function (id, toolId, toolReleaseVersion, toggleSkillEnabled, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.toggleDraftAgentInstanceSkillEnabled(id, toolId, toolReleaseVersion, toggleSkillEnabled, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a agent
         * @param {string} id
         * @param {AgentUpdate} agentUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgent: function (id, agentUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateAgent(id, agentUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a draft agent instance
         * @param {string} id
         * @param {AgentInstUpdate} agentInstUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraftAgentInstance: function (id, agentInstUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDraftAgentInstance(id, agentInstUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create or update knowledge of a draft agent instance
         * @param {string} id
         * @param {string} knwlBaseId
         * @param {KnowledgeUpsert} knowledgeUpsert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertDraftAgentInstanceKnowledge: function (id, knwlBaseId, knowledgeUpsert, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.upsertDraftAgentInstanceKnowledge(id, knwlBaseId, knowledgeUpsert, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * AgentApi - factory interface
 * @export
 */
exports.AgentApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.AgentApiFp(configuration);
    return {
        /**
         *
         * @summary Create an agent
         * @param {AgentCreation} agentCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgent: function (agentCreation, options) {
            return localVarFp.createAgent(agentCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create an instance of an agent
         * @param {string} id
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentInstance: function (id, version, options) {
            return localVarFp.createAgentInstance(id, version, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create or update a skill for a draft agent instance
         * @param {string} id
         * @param {string} toolId
         * @param {string} toolReleaseVersion
         * @param {SkillUpsert} skillUpsert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftAgentInstanceSkill: function (id, toolId, toolReleaseVersion, skillUpsert, options) {
            return localVarFp.createDraftAgentInstanceSkill(id, toolId, toolReleaseVersion, skillUpsert, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a agent
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgent: function (id, options) {
            return localVarFp.deleteAgent(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a agent instance by version, except draft version
         * @param {string} id
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentInstanceByVersion: function (id, version, options) {
            return localVarFp.deleteAgentInstanceByVersion(id, version, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete knowledge for a draft agent instance
         * @param {string} id
         * @param {string} knwlBaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDraftAgentInstanceKnowledge: function (id, knwlBaseId, options) {
            return localVarFp.deleteDraftAgentInstanceKnowledge(id, knwlBaseId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a skill for a draft agent instance
         * @param {string} id
         * @param {string} toolId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDraftAgentInstanceSkill: function (id, toolId, options) {
            return localVarFp.deleteDraftAgentInstanceSkill(id, toolId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get an agent by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentById: function (id, options) {
            return localVarFp.getAgentById(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all deployments of an agent
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentDeployment: function (id, options) {
            return localVarFp.getAgentDeployment(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get agent instance by version
         * @param {string} id
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentInstanceById: function (id, version, options) {
            return localVarFp.getAgentInstanceById(id, version, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all instance of an agent
         * @param {string} id
         * @param {boolean} includeDraft
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentInstances: function (id, includeDraft, options) {
            return localVarFp.getAgentInstances(id, includeDraft, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all available knowledge base of a draft agent instance
         * @param {string} id
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {string} [keyword] Keyword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftAgentInstanceAvailKnwlBase: function (id, page, size, keyword, options) {
            return localVarFp.getDraftAgentInstanceAvailKnwlBase(id, page, size, keyword, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all available tool release of a draft agent instance
         * @param {string} id
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {string} [keyword] Keyword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftAgentInstanceAvailToolReleases: function (id, page, size, keyword, options) {
            return localVarFp.getDraftAgentInstanceAvailToolReleases(id, page, size, keyword, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all knowledge of draft agent instance
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftAgentInstanceKnowledge: function (id, options) {
            return localVarFp.getDraftAgentInstanceKnowledge(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all skills of draft agent instance
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftAgentInstanceSkills: function (id, options) {
            return localVarFp.getDraftAgentInstanceSkills(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Enable a draft agent instance greeting text
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleDraftAgentInstanceGreetingEnabled: function (id, options) {
            return localVarFp.toggleDraftAgentInstanceGreetingEnabled(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Enable/disable a skill for a draft agent instance
         * @param {string} id
         * @param {string} toolId
         * @param {string} toolReleaseVersion
         * @param {ToggleSkillEnabled} toggleSkillEnabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleDraftAgentInstanceSkillEnabled: function (id, toolId, toolReleaseVersion, toggleSkillEnabled, options) {
            return localVarFp.toggleDraftAgentInstanceSkillEnabled(id, toolId, toolReleaseVersion, toggleSkillEnabled, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a agent
         * @param {string} id
         * @param {AgentUpdate} agentUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgent: function (id, agentUpdate, options) {
            return localVarFp.updateAgent(id, agentUpdate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a draft agent instance
         * @param {string} id
         * @param {AgentInstUpdate} agentInstUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraftAgentInstance: function (id, agentInstUpdate, options) {
            return localVarFp.updateDraftAgentInstance(id, agentInstUpdate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create or update knowledge of a draft agent instance
         * @param {string} id
         * @param {string} knwlBaseId
         * @param {KnowledgeUpsert} knowledgeUpsert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertDraftAgentInstanceKnowledge: function (id, knwlBaseId, knowledgeUpsert, options) {
            return localVarFp.upsertDraftAgentInstanceKnowledge(id, knwlBaseId, knowledgeUpsert, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * AgentApi - object-oriented interface
 * @export
 * @class AgentApi
 * @extends {BaseAPI}
 */
var AgentApi = /** @class */ (function (_super) {
    __extends(AgentApi, _super);
    function AgentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create an agent
     * @param {AgentCreation} agentCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.createAgent = function (agentCreation, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).createAgent(agentCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create an instance of an agent
     * @param {string} id
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.createAgentInstance = function (id, version, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).createAgentInstance(id, version, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create or update a skill for a draft agent instance
     * @param {string} id
     * @param {string} toolId
     * @param {string} toolReleaseVersion
     * @param {SkillUpsert} skillUpsert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.createDraftAgentInstanceSkill = function (id, toolId, toolReleaseVersion, skillUpsert, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).createDraftAgentInstanceSkill(id, toolId, toolReleaseVersion, skillUpsert, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a agent
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.deleteAgent = function (id, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).deleteAgent(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a agent instance by version, except draft version
     * @param {string} id
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.deleteAgentInstanceByVersion = function (id, version, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).deleteAgentInstanceByVersion(id, version, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete knowledge for a draft agent instance
     * @param {string} id
     * @param {string} knwlBaseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.deleteDraftAgentInstanceKnowledge = function (id, knwlBaseId, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).deleteDraftAgentInstanceKnowledge(id, knwlBaseId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a skill for a draft agent instance
     * @param {string} id
     * @param {string} toolId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.deleteDraftAgentInstanceSkill = function (id, toolId, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).deleteDraftAgentInstanceSkill(id, toolId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get an agent by ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.getAgentById = function (id, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).getAgentById(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all deployments of an agent
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.getAgentDeployment = function (id, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).getAgentDeployment(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get agent instance by version
     * @param {string} id
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.getAgentInstanceById = function (id, version, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).getAgentInstanceById(id, version, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all instance of an agent
     * @param {string} id
     * @param {boolean} includeDraft
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.getAgentInstances = function (id, includeDraft, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).getAgentInstances(id, includeDraft, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all available knowledge base of a draft agent instance
     * @param {string} id
     * @param {number} page Page index (0-based)
     * @param {number} size Page size
     * @param {string} [keyword] Keyword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.getDraftAgentInstanceAvailKnwlBase = function (id, page, size, keyword, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).getDraftAgentInstanceAvailKnwlBase(id, page, size, keyword, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all available tool release of a draft agent instance
     * @param {string} id
     * @param {number} page Page index (0-based)
     * @param {number} size Page size
     * @param {string} [keyword] Keyword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.getDraftAgentInstanceAvailToolReleases = function (id, page, size, keyword, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).getDraftAgentInstanceAvailToolReleases(id, page, size, keyword, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all knowledge of draft agent instance
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.getDraftAgentInstanceKnowledge = function (id, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).getDraftAgentInstanceKnowledge(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all skills of draft agent instance
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.getDraftAgentInstanceSkills = function (id, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).getDraftAgentInstanceSkills(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Enable a draft agent instance greeting text
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.toggleDraftAgentInstanceGreetingEnabled = function (id, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).toggleDraftAgentInstanceGreetingEnabled(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Enable/disable a skill for a draft agent instance
     * @param {string} id
     * @param {string} toolId
     * @param {string} toolReleaseVersion
     * @param {ToggleSkillEnabled} toggleSkillEnabled
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.toggleDraftAgentInstanceSkillEnabled = function (id, toolId, toolReleaseVersion, toggleSkillEnabled, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).toggleDraftAgentInstanceSkillEnabled(id, toolId, toolReleaseVersion, toggleSkillEnabled, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a agent
     * @param {string} id
     * @param {AgentUpdate} agentUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.updateAgent = function (id, agentUpdate, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).updateAgent(id, agentUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a draft agent instance
     * @param {string} id
     * @param {AgentInstUpdate} agentInstUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.updateDraftAgentInstance = function (id, agentInstUpdate, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).updateDraftAgentInstance(id, agentInstUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create or update knowledge of a draft agent instance
     * @param {string} id
     * @param {string} knwlBaseId
     * @param {KnowledgeUpsert} knowledgeUpsert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    AgentApi.prototype.upsertDraftAgentInstanceKnowledge = function (id, knwlBaseId, knowledgeUpsert, options) {
        var _this = this;
        return exports.AgentApiFp(this.configuration).upsertDraftAgentInstanceKnowledge(id, knwlBaseId, knowledgeUpsert, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AgentApi;
}(base_1.BaseAPI));
exports.AgentApi = AgentApi;
/**
 * AuthApi - axios parameter creator
 * @export
 */
exports.AuthApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/auth/me";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * AuthApi - functional programming interface
 * @export
 */
exports.AuthApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.AuthApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMe(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * AuthApi - factory interface
 * @export
 */
exports.AuthApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.AuthApiFp(configuration);
    return {
        /**
         *
         * @summary Get current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: function (options) {
            return localVarFp.getMe(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
var AuthApi = /** @class */ (function (_super) {
    __extends(AuthApi, _super);
    function AuthApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    AuthApi.prototype.getMe = function (options) {
        var _this = this;
        return exports.AuthApiFp(this.configuration).getMe(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AuthApi;
}(base_1.BaseAPI));
exports.AuthApi = AuthApi;
/**
 * BlobApi - axios parameter creator
 * @export
 */
exports.BlobApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Upload a file as blob
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlob: function (file, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'file' is not null or undefined
                            common_1.assertParamExists('createBlob', 'file', file);
                            localVarPath = "/api/blob";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Download a blob by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBlob: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('downloadBlob', 'id', id);
                            localVarPath = "/api/blob/{id}/download"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * BlobApi - functional programming interface
 * @export
 */
exports.BlobApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.BlobApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Upload a file as blob
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlob: function (file, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBlob(file, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Download a blob by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBlob: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.downloadBlob(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * BlobApi - factory interface
 * @export
 */
exports.BlobApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.BlobApiFp(configuration);
    return {
        /**
         *
         * @summary Upload a file as blob
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlob: function (file, options) {
            return localVarFp.createBlob(file, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Download a blob by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBlob: function (id, options) {
            return localVarFp.downloadBlob(id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * BlobApi - object-oriented interface
 * @export
 * @class BlobApi
 * @extends {BaseAPI}
 */
var BlobApi = /** @class */ (function (_super) {
    __extends(BlobApi, _super);
    function BlobApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Upload a file as blob
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlobApi
     */
    BlobApi.prototype.createBlob = function (file, options) {
        var _this = this;
        return exports.BlobApiFp(this.configuration).createBlob(file, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Download a blob by id
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlobApi
     */
    BlobApi.prototype.downloadBlob = function (id, options) {
        var _this = this;
        return exports.BlobApiFp(this.configuration).downloadBlob(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BlobApi;
}(base_1.BaseAPI));
exports.BlobApi = BlobApi;
/**
 * BotApi - axios parameter creator
 * @export
 */
exports.BotApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create a bot
         * @param {BotCreation} botCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBot: function (botCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'botCreation' is not null or undefined
                            common_1.assertParamExists('createBot', 'botCreation', botCreation);
                            localVarPath = "/api/bot";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(botCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a bot
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBot: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('deleteBot', 'id', id);
                            localVarPath = "/api/bot/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get bot
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBot: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getBot', 'id', id);
                            localVarPath = "/api/bot/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get bot link
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBotLink: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getBotLink', 'id', id);
                            localVarPath = "/api/bot/{id}/link"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Toggle bot debugging
         * @param {string} id
         * @param {ToggleBotDebug} toggleBotDebug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleBotDebug: function (id, toggleBotDebug, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('toggleBotDebug', 'id', id);
                            // verify required parameter 'toggleBotDebug' is not null or undefined
                            common_1.assertParamExists('toggleBotDebug', 'toggleBotDebug', toggleBotDebug);
                            localVarPath = "/api/bot/{id}/toggle-debug"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(toggleBotDebug, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a bot
         * @param {string} id
         * @param {BotUpdates} botUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBot: function (id, botUpdates, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('updateBot', 'id', id);
                            // verify required parameter 'botUpdates' is not null or undefined
                            common_1.assertParamExists('updateBot', 'botUpdates', botUpdates);
                            localVarPath = "/api/bot/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(botUpdates, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * BotApi - functional programming interface
 * @export
 */
exports.BotApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.BotApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a bot
         * @param {BotCreation} botCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBot: function (botCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBot(botCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a bot
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBot: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteBot(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get bot
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBot: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBot(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get bot link
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBotLink: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBotLink(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Toggle bot debugging
         * @param {string} id
         * @param {ToggleBotDebug} toggleBotDebug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleBotDebug: function (id, toggleBotDebug, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.toggleBotDebug(id, toggleBotDebug, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a bot
         * @param {string} id
         * @param {BotUpdates} botUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBot: function (id, botUpdates, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateBot(id, botUpdates, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * BotApi - factory interface
 * @export
 */
exports.BotApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.BotApiFp(configuration);
    return {
        /**
         *
         * @summary Create a bot
         * @param {BotCreation} botCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBot: function (botCreation, options) {
            return localVarFp.createBot(botCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a bot
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBot: function (id, options) {
            return localVarFp.deleteBot(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get bot
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBot: function (id, options) {
            return localVarFp.getBot(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get bot link
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBotLink: function (id, options) {
            return localVarFp.getBotLink(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Toggle bot debugging
         * @param {string} id
         * @param {ToggleBotDebug} toggleBotDebug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleBotDebug: function (id, toggleBotDebug, options) {
            return localVarFp.toggleBotDebug(id, toggleBotDebug, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a bot
         * @param {string} id
         * @param {BotUpdates} botUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBot: function (id, botUpdates, options) {
            return localVarFp.updateBot(id, botUpdates, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * BotApi - object-oriented interface
 * @export
 * @class BotApi
 * @extends {BaseAPI}
 */
var BotApi = /** @class */ (function (_super) {
    __extends(BotApi, _super);
    function BotApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a bot
     * @param {BotCreation} botCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BotApi
     */
    BotApi.prototype.createBot = function (botCreation, options) {
        var _this = this;
        return exports.BotApiFp(this.configuration).createBot(botCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a bot
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BotApi
     */
    BotApi.prototype.deleteBot = function (id, options) {
        var _this = this;
        return exports.BotApiFp(this.configuration).deleteBot(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get bot
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BotApi
     */
    BotApi.prototype.getBot = function (id, options) {
        var _this = this;
        return exports.BotApiFp(this.configuration).getBot(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get bot link
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BotApi
     */
    BotApi.prototype.getBotLink = function (id, options) {
        var _this = this;
        return exports.BotApiFp(this.configuration).getBotLink(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Toggle bot debugging
     * @param {string} id
     * @param {ToggleBotDebug} toggleBotDebug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BotApi
     */
    BotApi.prototype.toggleBotDebug = function (id, toggleBotDebug, options) {
        var _this = this;
        return exports.BotApiFp(this.configuration).toggleBotDebug(id, toggleBotDebug, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a bot
     * @param {string} id
     * @param {BotUpdates} botUpdates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BotApi
     */
    BotApi.prototype.updateBot = function (id, botUpdates, options) {
        var _this = this;
        return exports.BotApiFp(this.configuration).updateBot(id, botUpdates, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BotApi;
}(base_1.BaseAPI));
exports.BotApi = BotApi;
/**
 * ChannelApi - axios parameter creator
 * @export
 */
exports.ChannelApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Reset a channel
         * @param {string} channelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetChannel: function (channelId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'channelId' is not null or undefined
                            common_1.assertParamExists('resetChannel', 'channelId', channelId);
                            localVarPath = "/api/channel/{channelId}/reset"
                                .replace("{" + "channelId" + "}", encodeURIComponent(String(channelId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ChannelApi - functional programming interface
 * @export
 */
exports.ChannelApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.ChannelApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Reset a channel
         * @param {string} channelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetChannel: function (channelId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.resetChannel(channelId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * ChannelApi - factory interface
 * @export
 */
exports.ChannelApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.ChannelApiFp(configuration);
    return {
        /**
         *
         * @summary Reset a channel
         * @param {string} channelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetChannel: function (channelId, options) {
            return localVarFp.resetChannel(channelId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ChannelApi - object-oriented interface
 * @export
 * @class ChannelApi
 * @extends {BaseAPI}
 */
var ChannelApi = /** @class */ (function (_super) {
    __extends(ChannelApi, _super);
    function ChannelApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Reset a channel
     * @param {string} channelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChannelApi
     */
    ChannelApi.prototype.resetChannel = function (channelId, options) {
        var _this = this;
        return exports.ChannelApiFp(this.configuration).resetChannel(channelId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ChannelApi;
}(base_1.BaseAPI));
exports.ChannelApi = ChannelApi;
/**
 * ContentfulApi - axios parameter creator
 * @export
 */
exports.ContentfulApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asset: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('asset', 'id', id);
                            localVarPath = "/api/contentful/asset";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entries: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/contentful/entries";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entry: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('entry', 'id', id);
                            localVarPath = "/api/contentful/entry";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ContentfulApi - functional programming interface
 * @export
 */
exports.ContentfulApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.ContentfulApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asset: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.asset(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entries: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.entries(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entry: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.entry(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * ContentfulApi - factory interface
 * @export
 */
exports.ContentfulApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.ContentfulApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asset: function (id, options) {
            return localVarFp.asset(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entries: function (options) {
            return localVarFp.entries(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entry: function (id, options) {
            return localVarFp.entry(id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ContentfulApi - object-oriented interface
 * @export
 * @class ContentfulApi
 * @extends {BaseAPI}
 */
var ContentfulApi = /** @class */ (function (_super) {
    __extends(ContentfulApi, _super);
    function ContentfulApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentfulApi
     */
    ContentfulApi.prototype.asset = function (id, options) {
        var _this = this;
        return exports.ContentfulApiFp(this.configuration).asset(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentfulApi
     */
    ContentfulApi.prototype.entries = function (options) {
        var _this = this;
        return exports.ContentfulApiFp(this.configuration).entries(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentfulApi
     */
    ContentfulApi.prototype.entry = function (id, options) {
        var _this = this;
        return exports.ContentfulApiFp(this.configuration).entry(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ContentfulApi;
}(base_1.BaseAPI));
exports.ContentfulApi = ContentfulApi;
/**
 * DeploymentApi - axios parameter creator
 * @export
 */
exports.DeploymentApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create a deployment
         * @param {DeploymentCreation} deploymentCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeployment: function (deploymentCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'deploymentCreation' is not null or undefined
                            common_1.assertParamExists('createDeployment', 'deploymentCreation', deploymentCreation);
                            localVarPath = "/api/deployment";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(deploymentCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all bots of a deployment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeploymentBot: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getDeploymentBot', 'id', id);
                            localVarPath = "/api/deployment/{id}/bot"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a deployment by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeploymentById: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getDeploymentById', 'id', id);
                            localVarPath = "/api/deployment/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a deployment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDeploymentById: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('removeDeploymentById', 'id', id);
                            localVarPath = "/api/deployment/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a deployment
         * @param {string} id
         * @param {DeploymentUpdates} deploymentUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeployment: function (id, deploymentUpdates, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('updateDeployment', 'id', id);
                            // verify required parameter 'deploymentUpdates' is not null or undefined
                            common_1.assertParamExists('updateDeployment', 'deploymentUpdates', deploymentUpdates);
                            localVarPath = "/api/deployment/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(deploymentUpdates, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * DeploymentApi - functional programming interface
 * @export
 */
exports.DeploymentApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.DeploymentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a deployment
         * @param {DeploymentCreation} deploymentCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeployment: function (deploymentCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDeployment(deploymentCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all bots of a deployment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeploymentBot: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDeploymentBot(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a deployment by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeploymentById: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDeploymentById(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a deployment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDeploymentById: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeDeploymentById(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a deployment
         * @param {string} id
         * @param {DeploymentUpdates} deploymentUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeployment: function (id, deploymentUpdates, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDeployment(id, deploymentUpdates, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * DeploymentApi - factory interface
 * @export
 */
exports.DeploymentApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.DeploymentApiFp(configuration);
    return {
        /**
         *
         * @summary Create a deployment
         * @param {DeploymentCreation} deploymentCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeployment: function (deploymentCreation, options) {
            return localVarFp.createDeployment(deploymentCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all bots of a deployment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeploymentBot: function (id, options) {
            return localVarFp.getDeploymentBot(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a deployment by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeploymentById: function (id, options) {
            return localVarFp.getDeploymentById(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a deployment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDeploymentById: function (id, options) {
            return localVarFp.removeDeploymentById(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a deployment
         * @param {string} id
         * @param {DeploymentUpdates} deploymentUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeployment: function (id, deploymentUpdates, options) {
            return localVarFp.updateDeployment(id, deploymentUpdates, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * DeploymentApi - object-oriented interface
 * @export
 * @class DeploymentApi
 * @extends {BaseAPI}
 */
var DeploymentApi = /** @class */ (function (_super) {
    __extends(DeploymentApi, _super);
    function DeploymentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a deployment
     * @param {DeploymentCreation} deploymentCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeploymentApi
     */
    DeploymentApi.prototype.createDeployment = function (deploymentCreation, options) {
        var _this = this;
        return exports.DeploymentApiFp(this.configuration).createDeployment(deploymentCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all bots of a deployment
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeploymentApi
     */
    DeploymentApi.prototype.getDeploymentBot = function (id, options) {
        var _this = this;
        return exports.DeploymentApiFp(this.configuration).getDeploymentBot(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a deployment by ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeploymentApi
     */
    DeploymentApi.prototype.getDeploymentById = function (id, options) {
        var _this = this;
        return exports.DeploymentApiFp(this.configuration).getDeploymentById(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a deployment
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeploymentApi
     */
    DeploymentApi.prototype.removeDeploymentById = function (id, options) {
        var _this = this;
        return exports.DeploymentApiFp(this.configuration).removeDeploymentById(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a deployment
     * @param {string} id
     * @param {DeploymentUpdates} deploymentUpdates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeploymentApi
     */
    DeploymentApi.prototype.updateDeployment = function (id, deploymentUpdates, options) {
        var _this = this;
        return exports.DeploymentApiFp(this.configuration).updateDeployment(id, deploymentUpdates, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DeploymentApi;
}(base_1.BaseAPI));
exports.DeploymentApi = DeploymentApi;
/**
 * EnvironmentApi - axios parameter creator
 * @export
 */
exports.EnvironmentApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create a environment
         * @param {EnvCreation} envCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnv: function (envCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'envCreation' is not null or undefined
                            common_1.assertParamExists('createEnv', 'envCreation', envCreation);
                            localVarPath = "/api/env";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(envCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a environment variable
         * @param {string} id
         * @param {EnvVarCreation} envVarCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnvVar: function (id, envVarCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('createEnvVar', 'id', id);
                            // verify required parameter 'envVarCreation' is not null or undefined
                            common_1.assertParamExists('createEnvVar', 'envVarCreation', envVarCreation);
                            localVarPath = "/api/env/{id}/env-var"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(envVarCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a environment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEnv: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('deleteEnv', 'id', id);
                            localVarPath = "/api/env/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a environment variable
         * @param {string} id
         * @param {string} envVarId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEnvVar: function (id, envVarId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('deleteEnvVar', 'id', id);
                            // verify required parameter 'envVarId' is not null or undefined
                            common_1.assertParamExists('deleteEnvVar', 'envVarId', envVarId);
                            localVarPath = "/api/env/{id}/env-var/{envVarId}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)))
                                .replace("{" + "envVarId" + "}", encodeURIComponent(String(envVarId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a environment by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnvById: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getEnvById', 'id', id);
                            localVarPath = "/api/env/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Paginate environment variables of an environment
         * @param {string} id
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateEnvVar: function (id, page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('paginateEnvVar', 'id', id);
                            // verify required parameter 'page' is not null or undefined
                            common_1.assertParamExists('paginateEnvVar', 'page', page);
                            // verify required parameter 'size' is not null or undefined
                            common_1.assertParamExists('paginateEnvVar', 'size', size);
                            localVarPath = "/api/env/{id}/env-var"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary toggle a environment
         * @param {string} id
         * @param {ToggleEnvEnabled} toggleEnvEnabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleEnv: function (id, toggleEnvEnabled, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('toggleEnv', 'id', id);
                            // verify required parameter 'toggleEnvEnabled' is not null or undefined
                            common_1.assertParamExists('toggleEnv', 'toggleEnvEnabled', toggleEnvEnabled);
                            localVarPath = "/api/env/{id}/toggle-enable"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(toggleEnvEnabled, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a environment
         * @param {string} id
         * @param {EnvUpdate} envUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnv: function (id, envUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('updateEnv', 'id', id);
                            // verify required parameter 'envUpdate' is not null or undefined
                            common_1.assertParamExists('updateEnv', 'envUpdate', envUpdate);
                            localVarPath = "/api/env/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(envUpdate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a environment variable
         * @param {string} id
         * @param {string} envVarId
         * @param {EnvVarUpdate} envVarUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnvVar: function (id, envVarId, envVarUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('updateEnvVar', 'id', id);
                            // verify required parameter 'envVarId' is not null or undefined
                            common_1.assertParamExists('updateEnvVar', 'envVarId', envVarId);
                            // verify required parameter 'envVarUpdate' is not null or undefined
                            common_1.assertParamExists('updateEnvVar', 'envVarUpdate', envVarUpdate);
                            localVarPath = "/api/env/{id}/env-var/{envVarId}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)))
                                .replace("{" + "envVarId" + "}", encodeURIComponent(String(envVarId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(envVarUpdate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * EnvironmentApi - functional programming interface
 * @export
 */
exports.EnvironmentApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.EnvironmentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a environment
         * @param {EnvCreation} envCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnv: function (envCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createEnv(envCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a environment variable
         * @param {string} id
         * @param {EnvVarCreation} envVarCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnvVar: function (id, envVarCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createEnvVar(id, envVarCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a environment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEnv: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteEnv(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a environment variable
         * @param {string} id
         * @param {string} envVarId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEnvVar: function (id, envVarId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteEnvVar(id, envVarId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a environment by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnvById: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getEnvById(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Paginate environment variables of an environment
         * @param {string} id
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateEnvVar: function (id, page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paginateEnvVar(id, page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary toggle a environment
         * @param {string} id
         * @param {ToggleEnvEnabled} toggleEnvEnabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleEnv: function (id, toggleEnvEnabled, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.toggleEnv(id, toggleEnvEnabled, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a environment
         * @param {string} id
         * @param {EnvUpdate} envUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnv: function (id, envUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateEnv(id, envUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a environment variable
         * @param {string} id
         * @param {string} envVarId
         * @param {EnvVarUpdate} envVarUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnvVar: function (id, envVarId, envVarUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateEnvVar(id, envVarId, envVarUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * EnvironmentApi - factory interface
 * @export
 */
exports.EnvironmentApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.EnvironmentApiFp(configuration);
    return {
        /**
         *
         * @summary Create a environment
         * @param {EnvCreation} envCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnv: function (envCreation, options) {
            return localVarFp.createEnv(envCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a environment variable
         * @param {string} id
         * @param {EnvVarCreation} envVarCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnvVar: function (id, envVarCreation, options) {
            return localVarFp.createEnvVar(id, envVarCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a environment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEnv: function (id, options) {
            return localVarFp.deleteEnv(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a environment variable
         * @param {string} id
         * @param {string} envVarId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEnvVar: function (id, envVarId, options) {
            return localVarFp.deleteEnvVar(id, envVarId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a environment by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnvById: function (id, options) {
            return localVarFp.getEnvById(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Paginate environment variables of an environment
         * @param {string} id
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateEnvVar: function (id, page, size, options) {
            return localVarFp.paginateEnvVar(id, page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary toggle a environment
         * @param {string} id
         * @param {ToggleEnvEnabled} toggleEnvEnabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleEnv: function (id, toggleEnvEnabled, options) {
            return localVarFp.toggleEnv(id, toggleEnvEnabled, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a environment
         * @param {string} id
         * @param {EnvUpdate} envUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnv: function (id, envUpdate, options) {
            return localVarFp.updateEnv(id, envUpdate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a environment variable
         * @param {string} id
         * @param {string} envVarId
         * @param {EnvVarUpdate} envVarUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnvVar: function (id, envVarId, envVarUpdate, options) {
            return localVarFp.updateEnvVar(id, envVarId, envVarUpdate, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * EnvironmentApi - object-oriented interface
 * @export
 * @class EnvironmentApi
 * @extends {BaseAPI}
 */
var EnvironmentApi = /** @class */ (function (_super) {
    __extends(EnvironmentApi, _super);
    function EnvironmentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a environment
     * @param {EnvCreation} envCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentApi
     */
    EnvironmentApi.prototype.createEnv = function (envCreation, options) {
        var _this = this;
        return exports.EnvironmentApiFp(this.configuration).createEnv(envCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a environment variable
     * @param {string} id
     * @param {EnvVarCreation} envVarCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentApi
     */
    EnvironmentApi.prototype.createEnvVar = function (id, envVarCreation, options) {
        var _this = this;
        return exports.EnvironmentApiFp(this.configuration).createEnvVar(id, envVarCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a environment
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentApi
     */
    EnvironmentApi.prototype.deleteEnv = function (id, options) {
        var _this = this;
        return exports.EnvironmentApiFp(this.configuration).deleteEnv(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a environment variable
     * @param {string} id
     * @param {string} envVarId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentApi
     */
    EnvironmentApi.prototype.deleteEnvVar = function (id, envVarId, options) {
        var _this = this;
        return exports.EnvironmentApiFp(this.configuration).deleteEnvVar(id, envVarId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a environment by ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentApi
     */
    EnvironmentApi.prototype.getEnvById = function (id, options) {
        var _this = this;
        return exports.EnvironmentApiFp(this.configuration).getEnvById(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Paginate environment variables of an environment
     * @param {string} id
     * @param {number} page Page index (0-based)
     * @param {number} size Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentApi
     */
    EnvironmentApi.prototype.paginateEnvVar = function (id, page, size, options) {
        var _this = this;
        return exports.EnvironmentApiFp(this.configuration).paginateEnvVar(id, page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary toggle a environment
     * @param {string} id
     * @param {ToggleEnvEnabled} toggleEnvEnabled
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentApi
     */
    EnvironmentApi.prototype.toggleEnv = function (id, toggleEnvEnabled, options) {
        var _this = this;
        return exports.EnvironmentApiFp(this.configuration).toggleEnv(id, toggleEnvEnabled, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a environment
     * @param {string} id
     * @param {EnvUpdate} envUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentApi
     */
    EnvironmentApi.prototype.updateEnv = function (id, envUpdate, options) {
        var _this = this;
        return exports.EnvironmentApiFp(this.configuration).updateEnv(id, envUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a environment variable
     * @param {string} id
     * @param {string} envVarId
     * @param {EnvVarUpdate} envVarUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironmentApi
     */
    EnvironmentApi.prototype.updateEnvVar = function (id, envVarId, envVarUpdate, options) {
        var _this = this;
        return exports.EnvironmentApiFp(this.configuration).updateEnvVar(id, envVarId, envVarUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EnvironmentApi;
}(base_1.BaseAPI));
exports.EnvironmentApi = EnvironmentApi;
/**
 * FetchApi - axios parameter creator
 * @export
 */
exports.FetchApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Paginate fetch events of a fetch
         * @param {string} fetchId
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateFetchEvents: function (fetchId, page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fetchId' is not null or undefined
                            common_1.assertParamExists('paginateFetchEvents', 'fetchId', fetchId);
                            // verify required parameter 'page' is not null or undefined
                            common_1.assertParamExists('paginateFetchEvents', 'page', page);
                            // verify required parameter 'size' is not null or undefined
                            common_1.assertParamExists('paginateFetchEvents', 'size', size);
                            localVarPath = "/api/fetch/{fetchId}/event"
                                .replace("{" + "fetchId" + "}", encodeURIComponent(String(fetchId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * FetchApi - functional programming interface
 * @export
 */
exports.FetchApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.FetchApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Paginate fetch events of a fetch
         * @param {string} fetchId
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateFetchEvents: function (fetchId, page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paginateFetchEvents(fetchId, page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * FetchApi - factory interface
 * @export
 */
exports.FetchApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.FetchApiFp(configuration);
    return {
        /**
         *
         * @summary Paginate fetch events of a fetch
         * @param {string} fetchId
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateFetchEvents: function (fetchId, page, size, options) {
            return localVarFp.paginateFetchEvents(fetchId, page, size, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * FetchApi - object-oriented interface
 * @export
 * @class FetchApi
 * @extends {BaseAPI}
 */
var FetchApi = /** @class */ (function (_super) {
    __extends(FetchApi, _super);
    function FetchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Paginate fetch events of a fetch
     * @param {string} fetchId
     * @param {number} page Page index (0-based)
     * @param {number} size Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FetchApi
     */
    FetchApi.prototype.paginateFetchEvents = function (fetchId, page, size, options) {
        var _this = this;
        return exports.FetchApiFp(this.configuration).paginateFetchEvents(fetchId, page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FetchApi;
}(base_1.BaseAPI));
exports.FetchApi = FetchApi;
/**
 * KnwlBaseApi - axios parameter creator
 * @export
 */
exports.KnwlBaseApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create a knowledge base
         * @param {KnwlBaseCreation} knwlBaseCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKnwlBase: function (knwlBaseCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'knwlBaseCreation' is not null or undefined
                            common_1.assertParamExists('createKnwlBase', 'knwlBaseCreation', knwlBaseCreation);
                            localVarPath = "/api/knwl-base";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(knwlBaseCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new authorization url for knowledge base auth process
         * @param {string} knwlBaseId
         * @param {string} processName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKnwlBaseAuthorizationUrl: function (knwlBaseId, processName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'knwlBaseId' is not null or undefined
                            common_1.assertParamExists('createKnwlBaseAuthorizationUrl', 'knwlBaseId', knwlBaseId);
                            // verify required parameter 'processName' is not null or undefined
                            common_1.assertParamExists('createKnwlBaseAuthorizationUrl', 'processName', processName);
                            localVarPath = "/api/knwl-base/{knwlBaseId}/auth-process/{processName}/auth"
                                .replace("{" + "knwlBaseId" + "}", encodeURIComponent(String(knwlBaseId)))
                                .replace("{" + "processName" + "}", encodeURIComponent(String(processName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a knowledge base
         * @param {string} knwlBaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteKnwlBase: function (knwlBaseId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'knwlBaseId' is not null or undefined
                            common_1.assertParamExists('deleteKnwlBase', 'knwlBaseId', knwlBaseId);
                            localVarPath = "/api/knwl-base/{knwlBaseId}"
                                .replace("{" + "knwlBaseId" + "}", encodeURIComponent(String(knwlBaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a knowledge base by ID
         * @param {string} knwlBaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnwlBase: function (knwlBaseId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'knwlBaseId' is not null or undefined
                            common_1.assertParamExists('getKnwlBase', 'knwlBaseId', knwlBaseId);
                            localVarPath = "/api/knwl-base/{knwlBaseId}"
                                .replace("{" + "knwlBaseId" + "}", encodeURIComponent(String(knwlBaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get auth processes of a knowledge base
         * @param {string} knwlBaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnwlBaseAuthProcesses: function (knwlBaseId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'knwlBaseId' is not null or undefined
                            common_1.assertParamExists('getKnwlBaseAuthProcesses', 'knwlBaseId', knwlBaseId);
                            localVarPath = "/api/knwl-base/{knwlBaseId}/auth-process"
                                .replace("{" + "knwlBaseId" + "}", encodeURIComponent(String(knwlBaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all schedules of a knowledge base
         * @param {string} knwlBaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listKnwlBaseSchedules: function (knwlBaseId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'knwlBaseId' is not null or undefined
                            common_1.assertParamExists('listKnwlBaseSchedules', 'knwlBaseId', knwlBaseId);
                            localVarPath = "/api/knwl-base/{knwlBaseId}/schedules"
                                .replace("{" + "knwlBaseId" + "}", encodeURIComponent(String(knwlBaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Paginate fetches of a knowledge base schedule
         * @param {string} knwlBaseId
         * @param {string} envName
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateKnwlBaseFetches: function (knwlBaseId, envName, page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'knwlBaseId' is not null or undefined
                            common_1.assertParamExists('paginateKnwlBaseFetches', 'knwlBaseId', knwlBaseId);
                            // verify required parameter 'envName' is not null or undefined
                            common_1.assertParamExists('paginateKnwlBaseFetches', 'envName', envName);
                            // verify required parameter 'page' is not null or undefined
                            common_1.assertParamExists('paginateKnwlBaseFetches', 'page', page);
                            // verify required parameter 'size' is not null or undefined
                            common_1.assertParamExists('paginateKnwlBaseFetches', 'size', size);
                            localVarPath = "/api/knwl-base/{knwlBaseId}/env/{envName}/fetch"
                                .replace("{" + "knwlBaseId" + "}", encodeURIComponent(String(knwlBaseId)))
                                .replace("{" + "envName" + "}", encodeURIComponent(String(envName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Query knowledge base
         * @param {string} knwlBaseId
         * @param {string} envName
         * @param {string} query Query
         * @param {number} topK Top-K
         * @param {number} [scoreThreshold] Score Threshold
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchKnwlBaseRecords: function (knwlBaseId, envName, query, topK, scoreThreshold, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'knwlBaseId' is not null or undefined
                            common_1.assertParamExists('searchKnwlBaseRecords', 'knwlBaseId', knwlBaseId);
                            // verify required parameter 'envName' is not null or undefined
                            common_1.assertParamExists('searchKnwlBaseRecords', 'envName', envName);
                            // verify required parameter 'query' is not null or undefined
                            common_1.assertParamExists('searchKnwlBaseRecords', 'query', query);
                            // verify required parameter 'topK' is not null or undefined
                            common_1.assertParamExists('searchKnwlBaseRecords', 'topK', topK);
                            localVarPath = "/api/knwl-base/{knwlBaseId}/env/{envName}/search"
                                .replace("{" + "knwlBaseId" + "}", encodeURIComponent(String(knwlBaseId)))
                                .replace("{" + "envName" + "}", encodeURIComponent(String(envName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (query !== undefined) {
                                localVarQueryParameter['query'] = query;
                            }
                            if (topK !== undefined) {
                                localVarQueryParameter['topK'] = topK;
                            }
                            if (scoreThreshold !== undefined) {
                                localVarQueryParameter['scoreThreshold'] = scoreThreshold;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Toggle knowledge base schedule enabled
         * @param {string} knwlBaseId
         * @param {string} envName
         * @param {ToggleKnwlBaseScheduleEnabled} toggleKnwlBaseScheduleEnabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleFetchSchedules: function (knwlBaseId, envName, toggleKnwlBaseScheduleEnabled, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'knwlBaseId' is not null or undefined
                            common_1.assertParamExists('toggleFetchSchedules', 'knwlBaseId', knwlBaseId);
                            // verify required parameter 'envName' is not null or undefined
                            common_1.assertParamExists('toggleFetchSchedules', 'envName', envName);
                            // verify required parameter 'toggleKnwlBaseScheduleEnabled' is not null or undefined
                            common_1.assertParamExists('toggleFetchSchedules', 'toggleKnwlBaseScheduleEnabled', toggleKnwlBaseScheduleEnabled);
                            localVarPath = "/api/knwl-base/{knwlBaseId}/env/{envName}/enabled"
                                .replace("{" + "knwlBaseId" + "}", encodeURIComponent(String(knwlBaseId)))
                                .replace("{" + "envName" + "}", encodeURIComponent(String(envName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(toggleKnwlBaseScheduleEnabled, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Trigger a new fetch of a knowledge base schedule
         * @param {string} knwlBaseId
         * @param {string} envName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerNewFetch: function (knwlBaseId, envName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'knwlBaseId' is not null or undefined
                            common_1.assertParamExists('triggerNewFetch', 'knwlBaseId', knwlBaseId);
                            // verify required parameter 'envName' is not null or undefined
                            common_1.assertParamExists('triggerNewFetch', 'envName', envName);
                            localVarPath = "/api/knwl-base/{knwlBaseId}/env/{envName}/fetch"
                                .replace("{" + "knwlBaseId" + "}", encodeURIComponent(String(knwlBaseId)))
                                .replace("{" + "envName" + "}", encodeURIComponent(String(envName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a knowledge base
         * @param {string} knwlBaseId
         * @param {KnwlBaseUpdates} knwlBaseUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKnwlBase: function (knwlBaseId, knwlBaseUpdates, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'knwlBaseId' is not null or undefined
                            common_1.assertParamExists('updateKnwlBase', 'knwlBaseId', knwlBaseId);
                            // verify required parameter 'knwlBaseUpdates' is not null or undefined
                            common_1.assertParamExists('updateKnwlBase', 'knwlBaseUpdates', knwlBaseUpdates);
                            localVarPath = "/api/knwl-base/{knwlBaseId}"
                                .replace("{" + "knwlBaseId" + "}", encodeURIComponent(String(knwlBaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(knwlBaseUpdates, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * KnwlBaseApi - functional programming interface
 * @export
 */
exports.KnwlBaseApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.KnwlBaseApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a knowledge base
         * @param {KnwlBaseCreation} knwlBaseCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKnwlBase: function (knwlBaseCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createKnwlBase(knwlBaseCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new authorization url for knowledge base auth process
         * @param {string} knwlBaseId
         * @param {string} processName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKnwlBaseAuthorizationUrl: function (knwlBaseId, processName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createKnwlBaseAuthorizationUrl(knwlBaseId, processName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a knowledge base
         * @param {string} knwlBaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteKnwlBase: function (knwlBaseId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteKnwlBase(knwlBaseId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a knowledge base by ID
         * @param {string} knwlBaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnwlBase: function (knwlBaseId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getKnwlBase(knwlBaseId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get auth processes of a knowledge base
         * @param {string} knwlBaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnwlBaseAuthProcesses: function (knwlBaseId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getKnwlBaseAuthProcesses(knwlBaseId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all schedules of a knowledge base
         * @param {string} knwlBaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listKnwlBaseSchedules: function (knwlBaseId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listKnwlBaseSchedules(knwlBaseId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Paginate fetches of a knowledge base schedule
         * @param {string} knwlBaseId
         * @param {string} envName
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateKnwlBaseFetches: function (knwlBaseId, envName, page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paginateKnwlBaseFetches(knwlBaseId, envName, page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Query knowledge base
         * @param {string} knwlBaseId
         * @param {string} envName
         * @param {string} query Query
         * @param {number} topK Top-K
         * @param {number} [scoreThreshold] Score Threshold
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchKnwlBaseRecords: function (knwlBaseId, envName, query, topK, scoreThreshold, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchKnwlBaseRecords(knwlBaseId, envName, query, topK, scoreThreshold, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Toggle knowledge base schedule enabled
         * @param {string} knwlBaseId
         * @param {string} envName
         * @param {ToggleKnwlBaseScheduleEnabled} toggleKnwlBaseScheduleEnabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleFetchSchedules: function (knwlBaseId, envName, toggleKnwlBaseScheduleEnabled, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.toggleFetchSchedules(knwlBaseId, envName, toggleKnwlBaseScheduleEnabled, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Trigger a new fetch of a knowledge base schedule
         * @param {string} knwlBaseId
         * @param {string} envName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerNewFetch: function (knwlBaseId, envName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.triggerNewFetch(knwlBaseId, envName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a knowledge base
         * @param {string} knwlBaseId
         * @param {KnwlBaseUpdates} knwlBaseUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKnwlBase: function (knwlBaseId, knwlBaseUpdates, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateKnwlBase(knwlBaseId, knwlBaseUpdates, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * KnwlBaseApi - factory interface
 * @export
 */
exports.KnwlBaseApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.KnwlBaseApiFp(configuration);
    return {
        /**
         *
         * @summary Create a knowledge base
         * @param {KnwlBaseCreation} knwlBaseCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKnwlBase: function (knwlBaseCreation, options) {
            return localVarFp.createKnwlBase(knwlBaseCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new authorization url for knowledge base auth process
         * @param {string} knwlBaseId
         * @param {string} processName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKnwlBaseAuthorizationUrl: function (knwlBaseId, processName, options) {
            return localVarFp.createKnwlBaseAuthorizationUrl(knwlBaseId, processName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a knowledge base
         * @param {string} knwlBaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteKnwlBase: function (knwlBaseId, options) {
            return localVarFp.deleteKnwlBase(knwlBaseId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a knowledge base by ID
         * @param {string} knwlBaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnwlBase: function (knwlBaseId, options) {
            return localVarFp.getKnwlBase(knwlBaseId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get auth processes of a knowledge base
         * @param {string} knwlBaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnwlBaseAuthProcesses: function (knwlBaseId, options) {
            return localVarFp.getKnwlBaseAuthProcesses(knwlBaseId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all schedules of a knowledge base
         * @param {string} knwlBaseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listKnwlBaseSchedules: function (knwlBaseId, options) {
            return localVarFp.listKnwlBaseSchedules(knwlBaseId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Paginate fetches of a knowledge base schedule
         * @param {string} knwlBaseId
         * @param {string} envName
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateKnwlBaseFetches: function (knwlBaseId, envName, page, size, options) {
            return localVarFp.paginateKnwlBaseFetches(knwlBaseId, envName, page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Query knowledge base
         * @param {string} knwlBaseId
         * @param {string} envName
         * @param {string} query Query
         * @param {number} topK Top-K
         * @param {number} [scoreThreshold] Score Threshold
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchKnwlBaseRecords: function (knwlBaseId, envName, query, topK, scoreThreshold, options) {
            return localVarFp.searchKnwlBaseRecords(knwlBaseId, envName, query, topK, scoreThreshold, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Toggle knowledge base schedule enabled
         * @param {string} knwlBaseId
         * @param {string} envName
         * @param {ToggleKnwlBaseScheduleEnabled} toggleKnwlBaseScheduleEnabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleFetchSchedules: function (knwlBaseId, envName, toggleKnwlBaseScheduleEnabled, options) {
            return localVarFp.toggleFetchSchedules(knwlBaseId, envName, toggleKnwlBaseScheduleEnabled, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Trigger a new fetch of a knowledge base schedule
         * @param {string} knwlBaseId
         * @param {string} envName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerNewFetch: function (knwlBaseId, envName, options) {
            return localVarFp.triggerNewFetch(knwlBaseId, envName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a knowledge base
         * @param {string} knwlBaseId
         * @param {KnwlBaseUpdates} knwlBaseUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKnwlBase: function (knwlBaseId, knwlBaseUpdates, options) {
            return localVarFp.updateKnwlBase(knwlBaseId, knwlBaseUpdates, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * KnwlBaseApi - object-oriented interface
 * @export
 * @class KnwlBaseApi
 * @extends {BaseAPI}
 */
var KnwlBaseApi = /** @class */ (function (_super) {
    __extends(KnwlBaseApi, _super);
    function KnwlBaseApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a knowledge base
     * @param {KnwlBaseCreation} knwlBaseCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnwlBaseApi
     */
    KnwlBaseApi.prototype.createKnwlBase = function (knwlBaseCreation, options) {
        var _this = this;
        return exports.KnwlBaseApiFp(this.configuration).createKnwlBase(knwlBaseCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new authorization url for knowledge base auth process
     * @param {string} knwlBaseId
     * @param {string} processName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnwlBaseApi
     */
    KnwlBaseApi.prototype.createKnwlBaseAuthorizationUrl = function (knwlBaseId, processName, options) {
        var _this = this;
        return exports.KnwlBaseApiFp(this.configuration).createKnwlBaseAuthorizationUrl(knwlBaseId, processName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a knowledge base
     * @param {string} knwlBaseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnwlBaseApi
     */
    KnwlBaseApi.prototype.deleteKnwlBase = function (knwlBaseId, options) {
        var _this = this;
        return exports.KnwlBaseApiFp(this.configuration).deleteKnwlBase(knwlBaseId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a knowledge base by ID
     * @param {string} knwlBaseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnwlBaseApi
     */
    KnwlBaseApi.prototype.getKnwlBase = function (knwlBaseId, options) {
        var _this = this;
        return exports.KnwlBaseApiFp(this.configuration).getKnwlBase(knwlBaseId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get auth processes of a knowledge base
     * @param {string} knwlBaseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnwlBaseApi
     */
    KnwlBaseApi.prototype.getKnwlBaseAuthProcesses = function (knwlBaseId, options) {
        var _this = this;
        return exports.KnwlBaseApiFp(this.configuration).getKnwlBaseAuthProcesses(knwlBaseId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all schedules of a knowledge base
     * @param {string} knwlBaseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnwlBaseApi
     */
    KnwlBaseApi.prototype.listKnwlBaseSchedules = function (knwlBaseId, options) {
        var _this = this;
        return exports.KnwlBaseApiFp(this.configuration).listKnwlBaseSchedules(knwlBaseId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Paginate fetches of a knowledge base schedule
     * @param {string} knwlBaseId
     * @param {string} envName
     * @param {number} page Page index (0-based)
     * @param {number} size Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnwlBaseApi
     */
    KnwlBaseApi.prototype.paginateKnwlBaseFetches = function (knwlBaseId, envName, page, size, options) {
        var _this = this;
        return exports.KnwlBaseApiFp(this.configuration).paginateKnwlBaseFetches(knwlBaseId, envName, page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Query knowledge base
     * @param {string} knwlBaseId
     * @param {string} envName
     * @param {string} query Query
     * @param {number} topK Top-K
     * @param {number} [scoreThreshold] Score Threshold
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnwlBaseApi
     */
    KnwlBaseApi.prototype.searchKnwlBaseRecords = function (knwlBaseId, envName, query, topK, scoreThreshold, options) {
        var _this = this;
        return exports.KnwlBaseApiFp(this.configuration).searchKnwlBaseRecords(knwlBaseId, envName, query, topK, scoreThreshold, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Toggle knowledge base schedule enabled
     * @param {string} knwlBaseId
     * @param {string} envName
     * @param {ToggleKnwlBaseScheduleEnabled} toggleKnwlBaseScheduleEnabled
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnwlBaseApi
     */
    KnwlBaseApi.prototype.toggleFetchSchedules = function (knwlBaseId, envName, toggleKnwlBaseScheduleEnabled, options) {
        var _this = this;
        return exports.KnwlBaseApiFp(this.configuration).toggleFetchSchedules(knwlBaseId, envName, toggleKnwlBaseScheduleEnabled, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Trigger a new fetch of a knowledge base schedule
     * @param {string} knwlBaseId
     * @param {string} envName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnwlBaseApi
     */
    KnwlBaseApi.prototype.triggerNewFetch = function (knwlBaseId, envName, options) {
        var _this = this;
        return exports.KnwlBaseApiFp(this.configuration).triggerNewFetch(knwlBaseId, envName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a knowledge base
     * @param {string} knwlBaseId
     * @param {KnwlBaseUpdates} knwlBaseUpdates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KnwlBaseApi
     */
    KnwlBaseApi.prototype.updateKnwlBase = function (knwlBaseId, knwlBaseUpdates, options) {
        var _this = this;
        return exports.KnwlBaseApiFp(this.configuration).updateKnwlBase(knwlBaseId, knwlBaseUpdates, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return KnwlBaseApi;
}(base_1.BaseAPI));
exports.KnwlBaseApi = KnwlBaseApi;
/**
 * LoaderApi - axios parameter creator
 * @export
 */
exports.LoaderApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create a loader
         * @param {LoaderCreation} loaderCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoader: function (loaderCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loaderCreation' is not null or undefined
                            common_1.assertParamExists('createLoader', 'loaderCreation', loaderCreation);
                            localVarPath = "/api/loader";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(loaderCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new loader release from a draft
         * @param {string} loaderId
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoaderRelease: function (loaderId, version, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loaderId' is not null or undefined
                            common_1.assertParamExists('createLoaderRelease', 'loaderId', loaderId);
                            // verify required parameter 'version' is not null or undefined
                            common_1.assertParamExists('createLoaderRelease', 'version', version);
                            localVarPath = "/api/loader/{loaderId}/release/{version}"
                                .replace("{" + "loaderId" + "}", encodeURIComponent(String(loaderId)))
                                .replace("{" + "version" + "}", encodeURIComponent(String(version)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a loader
         * @param {string} loaderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoader: function (loaderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loaderId' is not null or undefined
                            common_1.assertParamExists('deleteLoader', 'loaderId', loaderId);
                            localVarPath = "/api/loader/{loaderId}"
                                .replace("{" + "loaderId" + "}", encodeURIComponent(String(loaderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a loader release
         * @param {string} loaderId
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoaderRelease: function (loaderId, version, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loaderId' is not null or undefined
                            common_1.assertParamExists('deleteLoaderRelease', 'loaderId', loaderId);
                            // verify required parameter 'version' is not null or undefined
                            common_1.assertParamExists('deleteLoaderRelease', 'version', version);
                            localVarPath = "/api/loader/{loaderId}/release/{version}"
                                .replace("{" + "loaderId" + "}", encodeURIComponent(String(loaderId)))
                                .replace("{" + "version" + "}", encodeURIComponent(String(version)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a loader by ID
         * @param {string} loaderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoader: function (loaderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loaderId' is not null or undefined
                            common_1.assertParamExists('getLoader', 'loaderId', loaderId);
                            localVarPath = "/api/loader/{loaderId}"
                                .replace("{" + "loaderId" + "}", encodeURIComponent(String(loaderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all release of a loader
         * @param {string} loaderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoaderReleaseByLoader: function (loaderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loaderId' is not null or undefined
                            common_1.assertParamExists('getLoaderReleaseByLoader', 'loaderId', loaderId);
                            localVarPath = "/api/loader/{loaderId}/release"
                                .replace("{" + "loaderId" + "}", encodeURIComponent(String(loaderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a loader release
         * @param {string} loaderId
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoaderReleaseByVersion: function (loaderId, version, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loaderId' is not null or undefined
                            common_1.assertParamExists('getLoaderReleaseByVersion', 'loaderId', loaderId);
                            // verify required parameter 'version' is not null or undefined
                            common_1.assertParamExists('getLoaderReleaseByVersion', 'version', version);
                            localVarPath = "/api/loader/{loaderId}/release/{version}"
                                .replace("{" + "loaderId" + "}", encodeURIComponent(String(loaderId)))
                                .replace("{" + "version" + "}", encodeURIComponent(String(version)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a draft loader release
         * @param {string} loaderId
         * @param {LoaderReleaseUpdates} loaderReleaseUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraftRelease1: function (loaderId, loaderReleaseUpdates, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loaderId' is not null or undefined
                            common_1.assertParamExists('updateDraftRelease1', 'loaderId', loaderId);
                            // verify required parameter 'loaderReleaseUpdates' is not null or undefined
                            common_1.assertParamExists('updateDraftRelease1', 'loaderReleaseUpdates', loaderReleaseUpdates);
                            localVarPath = "/api/loader/{loaderId}/release/draft"
                                .replace("{" + "loaderId" + "}", encodeURIComponent(String(loaderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(loaderReleaseUpdates, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a loader
         * @param {string} loaderId
         * @param {LoaderUpdates} loaderUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoader: function (loaderId, loaderUpdates, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loaderId' is not null or undefined
                            common_1.assertParamExists('updateLoader', 'loaderId', loaderId);
                            // verify required parameter 'loaderUpdates' is not null or undefined
                            common_1.assertParamExists('updateLoader', 'loaderUpdates', loaderUpdates);
                            localVarPath = "/api/loader/{loaderId}"
                                .replace("{" + "loaderId" + "}", encodeURIComponent(String(loaderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(loaderUpdates, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * LoaderApi - functional programming interface
 * @export
 */
exports.LoaderApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.LoaderApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a loader
         * @param {LoaderCreation} loaderCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoader: function (loaderCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLoader(loaderCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new loader release from a draft
         * @param {string} loaderId
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoaderRelease: function (loaderId, version, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLoaderRelease(loaderId, version, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a loader
         * @param {string} loaderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoader: function (loaderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteLoader(loaderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a loader release
         * @param {string} loaderId
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoaderRelease: function (loaderId, version, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteLoaderRelease(loaderId, version, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a loader by ID
         * @param {string} loaderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoader: function (loaderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLoader(loaderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all release of a loader
         * @param {string} loaderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoaderReleaseByLoader: function (loaderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLoaderReleaseByLoader(loaderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a loader release
         * @param {string} loaderId
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoaderReleaseByVersion: function (loaderId, version, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLoaderReleaseByVersion(loaderId, version, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a draft loader release
         * @param {string} loaderId
         * @param {LoaderReleaseUpdates} loaderReleaseUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraftRelease1: function (loaderId, loaderReleaseUpdates, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDraftRelease1(loaderId, loaderReleaseUpdates, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a loader
         * @param {string} loaderId
         * @param {LoaderUpdates} loaderUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoader: function (loaderId, loaderUpdates, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateLoader(loaderId, loaderUpdates, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * LoaderApi - factory interface
 * @export
 */
exports.LoaderApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.LoaderApiFp(configuration);
    return {
        /**
         *
         * @summary Create a loader
         * @param {LoaderCreation} loaderCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoader: function (loaderCreation, options) {
            return localVarFp.createLoader(loaderCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new loader release from a draft
         * @param {string} loaderId
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoaderRelease: function (loaderId, version, options) {
            return localVarFp.createLoaderRelease(loaderId, version, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a loader
         * @param {string} loaderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoader: function (loaderId, options) {
            return localVarFp.deleteLoader(loaderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a loader release
         * @param {string} loaderId
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoaderRelease: function (loaderId, version, options) {
            return localVarFp.deleteLoaderRelease(loaderId, version, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a loader by ID
         * @param {string} loaderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoader: function (loaderId, options) {
            return localVarFp.getLoader(loaderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all release of a loader
         * @param {string} loaderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoaderReleaseByLoader: function (loaderId, options) {
            return localVarFp.getLoaderReleaseByLoader(loaderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a loader release
         * @param {string} loaderId
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoaderReleaseByVersion: function (loaderId, version, options) {
            return localVarFp.getLoaderReleaseByVersion(loaderId, version, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a draft loader release
         * @param {string} loaderId
         * @param {LoaderReleaseUpdates} loaderReleaseUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraftRelease1: function (loaderId, loaderReleaseUpdates, options) {
            return localVarFp.updateDraftRelease1(loaderId, loaderReleaseUpdates, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a loader
         * @param {string} loaderId
         * @param {LoaderUpdates} loaderUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoader: function (loaderId, loaderUpdates, options) {
            return localVarFp.updateLoader(loaderId, loaderUpdates, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * LoaderApi - object-oriented interface
 * @export
 * @class LoaderApi
 * @extends {BaseAPI}
 */
var LoaderApi = /** @class */ (function (_super) {
    __extends(LoaderApi, _super);
    function LoaderApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a loader
     * @param {LoaderCreation} loaderCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoaderApi
     */
    LoaderApi.prototype.createLoader = function (loaderCreation, options) {
        var _this = this;
        return exports.LoaderApiFp(this.configuration).createLoader(loaderCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new loader release from a draft
     * @param {string} loaderId
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoaderApi
     */
    LoaderApi.prototype.createLoaderRelease = function (loaderId, version, options) {
        var _this = this;
        return exports.LoaderApiFp(this.configuration).createLoaderRelease(loaderId, version, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a loader
     * @param {string} loaderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoaderApi
     */
    LoaderApi.prototype.deleteLoader = function (loaderId, options) {
        var _this = this;
        return exports.LoaderApiFp(this.configuration).deleteLoader(loaderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a loader release
     * @param {string} loaderId
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoaderApi
     */
    LoaderApi.prototype.deleteLoaderRelease = function (loaderId, version, options) {
        var _this = this;
        return exports.LoaderApiFp(this.configuration).deleteLoaderRelease(loaderId, version, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a loader by ID
     * @param {string} loaderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoaderApi
     */
    LoaderApi.prototype.getLoader = function (loaderId, options) {
        var _this = this;
        return exports.LoaderApiFp(this.configuration).getLoader(loaderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all release of a loader
     * @param {string} loaderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoaderApi
     */
    LoaderApi.prototype.getLoaderReleaseByLoader = function (loaderId, options) {
        var _this = this;
        return exports.LoaderApiFp(this.configuration).getLoaderReleaseByLoader(loaderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a loader release
     * @param {string} loaderId
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoaderApi
     */
    LoaderApi.prototype.getLoaderReleaseByVersion = function (loaderId, version, options) {
        var _this = this;
        return exports.LoaderApiFp(this.configuration).getLoaderReleaseByVersion(loaderId, version, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a draft loader release
     * @param {string} loaderId
     * @param {LoaderReleaseUpdates} loaderReleaseUpdates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoaderApi
     */
    LoaderApi.prototype.updateDraftRelease1 = function (loaderId, loaderReleaseUpdates, options) {
        var _this = this;
        return exports.LoaderApiFp(this.configuration).updateDraftRelease1(loaderId, loaderReleaseUpdates, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a loader
     * @param {string} loaderId
     * @param {LoaderUpdates} loaderUpdates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoaderApi
     */
    LoaderApi.prototype.updateLoader = function (loaderId, loaderUpdates, options) {
        var _this = this;
        return exports.LoaderApiFp(this.configuration).updateLoader(loaderId, loaderUpdates, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LoaderApi;
}(base_1.BaseAPI));
exports.LoaderApi = LoaderApi;
/**
 * OAuth2Api - axios parameter creator
 * @export
 */
exports.OAuth2ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary OAuth2 callback
         * @param {string} code
         * @param {string} state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2Callback: function (code, state, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'code' is not null or undefined
                            common_1.assertParamExists('oauth2Callback', 'code', code);
                            // verify required parameter 'state' is not null or undefined
                            common_1.assertParamExists('oauth2Callback', 'state', state);
                            localVarPath = "/api/oauth2/callback";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (code !== undefined) {
                                localVarQueryParameter['code'] = code;
                            }
                            if (state !== undefined) {
                                localVarQueryParameter['state'] = state;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * OAuth2Api - functional programming interface
 * @export
 */
exports.OAuth2ApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.OAuth2ApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary OAuth2 callback
         * @param {string} code
         * @param {string} state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2Callback: function (code, state, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.oauth2Callback(code, state, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * OAuth2Api - factory interface
 * @export
 */
exports.OAuth2ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.OAuth2ApiFp(configuration);
    return {
        /**
         *
         * @summary OAuth2 callback
         * @param {string} code
         * @param {string} state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2Callback: function (code, state, options) {
            return localVarFp.oauth2Callback(code, state, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * OAuth2Api - object-oriented interface
 * @export
 * @class OAuth2Api
 * @extends {BaseAPI}
 */
var OAuth2Api = /** @class */ (function (_super) {
    __extends(OAuth2Api, _super);
    function OAuth2Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary OAuth2 callback
     * @param {string} code
     * @param {string} state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OAuth2Api
     */
    OAuth2Api.prototype.oauth2Callback = function (code, state, options) {
        var _this = this;
        return exports.OAuth2ApiFp(this.configuration).oauth2Callback(code, state, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OAuth2Api;
}(base_1.BaseAPI));
exports.OAuth2Api = OAuth2Api;
/**
 * ProjectApi - axios parameter creator
 * @export
 */
exports.ProjectApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create a project
         * @param {ProjectCreation} projectCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: function (projectCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'projectCreation' is not null or undefined
                            common_1.assertParamExists('createProject', 'projectCreation', projectCreation);
                            localVarPath = "/api/project";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(projectCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a project
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('deleteProject', 'id', id);
                            localVarPath = "/api/project/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a project by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectById: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getProjectById', 'id', id);
                            localVarPath = "/api/project/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List agents of a project
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgents: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('listAgents', 'id', id);
                            localVarPath = "/api/project/{id}/agent"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List environments of a project
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEnvs: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('listEnvs', 'id', id);
                            localVarPath = "/api/project/{id}/env"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List knowledge bases of a project
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listKnwlBase: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('listKnwlBase', 'id', id);
                            localVarPath = "/api/project/{id}/knwl-base"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List project\'s available loader releases
         * @param {string} id
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {string} [keyword] Keyword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateProjectAvailLoaderReleases: function (id, page, size, keyword, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('paginateProjectAvailLoaderReleases', 'id', id);
                            // verify required parameter 'page' is not null or undefined
                            common_1.assertParamExists('paginateProjectAvailLoaderReleases', 'page', page);
                            // verify required parameter 'size' is not null or undefined
                            common_1.assertParamExists('paginateProjectAvailLoaderReleases', 'size', size);
                            localVarPath = "/api/project/{id}/avail-loader-release"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (keyword !== undefined) {
                                localVarQueryParameter['keyword'] = keyword;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary update a project info
         * @param {string} id
         * @param {ProjectUpdates} projectUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject: function (id, projectUpdates, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('updateProject', 'id', id);
                            // verify required parameter 'projectUpdates' is not null or undefined
                            common_1.assertParamExists('updateProject', 'projectUpdates', projectUpdates);
                            localVarPath = "/api/project/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(projectUpdates, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ProjectApi - functional programming interface
 * @export
 */
exports.ProjectApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.ProjectApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a project
         * @param {ProjectCreation} projectCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: function (projectCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createProject(projectCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a project
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteProject(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a project by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectById: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProjectById(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List agents of a project
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgents: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listAgents(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List environments of a project
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEnvs: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listEnvs(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List knowledge bases of a project
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listKnwlBase: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listKnwlBase(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List project\'s available loader releases
         * @param {string} id
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {string} [keyword] Keyword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateProjectAvailLoaderReleases: function (id, page, size, keyword, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paginateProjectAvailLoaderReleases(id, page, size, keyword, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary update a project info
         * @param {string} id
         * @param {ProjectUpdates} projectUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject: function (id, projectUpdates, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateProject(id, projectUpdates, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * ProjectApi - factory interface
 * @export
 */
exports.ProjectApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.ProjectApiFp(configuration);
    return {
        /**
         *
         * @summary Create a project
         * @param {ProjectCreation} projectCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: function (projectCreation, options) {
            return localVarFp.createProject(projectCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a project
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject: function (id, options) {
            return localVarFp.deleteProject(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a project by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectById: function (id, options) {
            return localVarFp.getProjectById(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List agents of a project
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgents: function (id, options) {
            return localVarFp.listAgents(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List environments of a project
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEnvs: function (id, options) {
            return localVarFp.listEnvs(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List knowledge bases of a project
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listKnwlBase: function (id, options) {
            return localVarFp.listKnwlBase(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List project\'s available loader releases
         * @param {string} id
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {string} [keyword] Keyword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateProjectAvailLoaderReleases: function (id, page, size, keyword, options) {
            return localVarFp.paginateProjectAvailLoaderReleases(id, page, size, keyword, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary update a project info
         * @param {string} id
         * @param {ProjectUpdates} projectUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProject: function (id, projectUpdates, options) {
            return localVarFp.updateProject(id, projectUpdates, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ProjectApi - object-oriented interface
 * @export
 * @class ProjectApi
 * @extends {BaseAPI}
 */
var ProjectApi = /** @class */ (function (_super) {
    __extends(ProjectApi, _super);
    function ProjectApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a project
     * @param {ProjectCreation} projectCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    ProjectApi.prototype.createProject = function (projectCreation, options) {
        var _this = this;
        return exports.ProjectApiFp(this.configuration).createProject(projectCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a project
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    ProjectApi.prototype.deleteProject = function (id, options) {
        var _this = this;
        return exports.ProjectApiFp(this.configuration).deleteProject(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a project by ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    ProjectApi.prototype.getProjectById = function (id, options) {
        var _this = this;
        return exports.ProjectApiFp(this.configuration).getProjectById(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List agents of a project
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    ProjectApi.prototype.listAgents = function (id, options) {
        var _this = this;
        return exports.ProjectApiFp(this.configuration).listAgents(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List environments of a project
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    ProjectApi.prototype.listEnvs = function (id, options) {
        var _this = this;
        return exports.ProjectApiFp(this.configuration).listEnvs(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List knowledge bases of a project
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    ProjectApi.prototype.listKnwlBase = function (id, options) {
        var _this = this;
        return exports.ProjectApiFp(this.configuration).listKnwlBase(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List project\'s available loader releases
     * @param {string} id
     * @param {number} page Page index (0-based)
     * @param {number} size Page size
     * @param {string} [keyword] Keyword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    ProjectApi.prototype.paginateProjectAvailLoaderReleases = function (id, page, size, keyword, options) {
        var _this = this;
        return exports.ProjectApiFp(this.configuration).paginateProjectAvailLoaderReleases(id, page, size, keyword, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary update a project info
     * @param {string} id
     * @param {ProjectUpdates} projectUpdates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    ProjectApi.prototype.updateProject = function (id, projectUpdates, options) {
        var _this = this;
        return exports.ProjectApiFp(this.configuration).updateProject(id, projectUpdates, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ProjectApi;
}(base_1.BaseAPI));
exports.ProjectApi = ProjectApi;
/**
 * TagApi - axios parameter creator
 * @export
 */
exports.TagApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Paginate tags
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {'TOOL_CATEGORY' | 'LOADER_CATEGORY'} [domain]
         * @param {string} [keyword]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateTag: function (page, size, domain, keyword, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            common_1.assertParamExists('paginateTag', 'page', page);
                            // verify required parameter 'size' is not null or undefined
                            common_1.assertParamExists('paginateTag', 'size', size);
                            localVarPath = "/api/tag";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (domain !== undefined) {
                                localVarQueryParameter['domain'] = domain;
                            }
                            if (keyword !== undefined) {
                                localVarQueryParameter['keyword'] = keyword;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * TagApi - functional programming interface
 * @export
 */
exports.TagApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.TagApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Paginate tags
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {'TOOL_CATEGORY' | 'LOADER_CATEGORY'} [domain]
         * @param {string} [keyword]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateTag: function (page, size, domain, keyword, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paginateTag(page, size, domain, keyword, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * TagApi - factory interface
 * @export
 */
exports.TagApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.TagApiFp(configuration);
    return {
        /**
         *
         * @summary Paginate tags
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {'TOOL_CATEGORY' | 'LOADER_CATEGORY'} [domain]
         * @param {string} [keyword]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateTag: function (page, size, domain, keyword, options) {
            return localVarFp.paginateTag(page, size, domain, keyword, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * TagApi - object-oriented interface
 * @export
 * @class TagApi
 * @extends {BaseAPI}
 */
var TagApi = /** @class */ (function (_super) {
    __extends(TagApi, _super);
    function TagApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Paginate tags
     * @param {number} page Page index (0-based)
     * @param {number} size Page size
     * @param {'TOOL_CATEGORY' | 'LOADER_CATEGORY'} [domain]
     * @param {string} [keyword]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    TagApi.prototype.paginateTag = function (page, size, domain, keyword, options) {
        var _this = this;
        return exports.TagApiFp(this.configuration).paginateTag(page, size, domain, keyword, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TagApi;
}(base_1.BaseAPI));
exports.TagApi = TagApi;
/**
 * TeamApi - axios parameter creator
 * @export
 */
exports.TeamApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary add a member to a team
         * @param {string} id
         * @param {BriefTeamMemberDto} briefTeamMemberDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTeamMember: function (id, briefTeamMemberDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('addTeamMember', 'id', id);
                            // verify required parameter 'briefTeamMemberDto' is not null or undefined
                            common_1.assertParamExists('addTeamMember', 'briefTeamMemberDto', briefTeamMemberDto);
                            localVarPath = "/api/team/{id}/member"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(briefTeamMemberDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary create a team
         * @param {TeamCreation} teamCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeam: function (teamCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'teamCreation' is not null or undefined
                            common_1.assertParamExists('createTeam', 'teamCreation', teamCreation);
                            localVarPath = "/api/team";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(teamCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary delete a team
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeam: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('deleteTeam', 'id', id);
                            localVarPath = "/api/team/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List a team\'s custom tools
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamTools: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('listTeamTools', 'id', id);
                            localVarPath = "/api/team/{id}/tool"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary paginate teams
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {string} [id] team id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateTeams: function (page, size, id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            common_1.assertParamExists('paginateTeams', 'page', page);
                            // verify required parameter 'size' is not null or undefined
                            common_1.assertParamExists('paginateTeams', 'size', size);
                            localVarPath = "/api/team/paginate";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary remove a member from a team
         * @param {string} teamId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMember: function (teamId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'teamId' is not null or undefined
                            common_1.assertParamExists('removeMember', 'teamId', teamId);
                            // verify required parameter 'userId' is not null or undefined
                            common_1.assertParamExists('removeMember', 'userId', userId);
                            localVarPath = "/api/team/{teamId}/member/{userId}"
                                .replace("{" + "teamId" + "}", encodeURIComponent(String(teamId)))
                                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary update a team
         * @param {string} id
         * @param {TeamUpdate} teamUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam: function (id, teamUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('updateTeam', 'id', id);
                            // verify required parameter 'teamUpdate' is not null or undefined
                            common_1.assertParamExists('updateTeam', 'teamUpdate', teamUpdate);
                            localVarPath = "/api/team/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(teamUpdate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary update a member of a team
         * @param {string} id
         * @param {TeamMemberUpdate} teamMemberUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamMember: function (id, teamMemberUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('updateTeamMember', 'id', id);
                            // verify required parameter 'teamMemberUpdate' is not null or undefined
                            common_1.assertParamExists('updateTeamMember', 'teamMemberUpdate', teamMemberUpdate);
                            localVarPath = "/api/team/member/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(teamMemberUpdate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * TeamApi - functional programming interface
 * @export
 */
exports.TeamApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.TeamApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary add a member to a team
         * @param {string} id
         * @param {BriefTeamMemberDto} briefTeamMemberDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTeamMember: function (id, briefTeamMemberDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addTeamMember(id, briefTeamMemberDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary create a team
         * @param {TeamCreation} teamCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeam: function (teamCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createTeam(teamCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary delete a team
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeam: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTeam(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List a team\'s custom tools
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamTools: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listTeamTools(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary paginate teams
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {string} [id] team id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateTeams: function (page, size, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paginateTeams(page, size, id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary remove a member from a team
         * @param {string} teamId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMember: function (teamId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeMember(teamId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary update a team
         * @param {string} id
         * @param {TeamUpdate} teamUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam: function (id, teamUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateTeam(id, teamUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary update a member of a team
         * @param {string} id
         * @param {TeamMemberUpdate} teamMemberUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamMember: function (id, teamMemberUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateTeamMember(id, teamMemberUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * TeamApi - factory interface
 * @export
 */
exports.TeamApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.TeamApiFp(configuration);
    return {
        /**
         *
         * @summary add a member to a team
         * @param {string} id
         * @param {BriefTeamMemberDto} briefTeamMemberDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTeamMember: function (id, briefTeamMemberDto, options) {
            return localVarFp.addTeamMember(id, briefTeamMemberDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary create a team
         * @param {TeamCreation} teamCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeam: function (teamCreation, options) {
            return localVarFp.createTeam(teamCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary delete a team
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeam: function (id, options) {
            return localVarFp.deleteTeam(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List a team\'s custom tools
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamTools: function (id, options) {
            return localVarFp.listTeamTools(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary paginate teams
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {string} [id] team id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginateTeams: function (page, size, id, options) {
            return localVarFp.paginateTeams(page, size, id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary remove a member from a team
         * @param {string} teamId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMember: function (teamId, userId, options) {
            return localVarFp.removeMember(teamId, userId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary update a team
         * @param {string} id
         * @param {TeamUpdate} teamUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam: function (id, teamUpdate, options) {
            return localVarFp.updateTeam(id, teamUpdate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary update a member of a team
         * @param {string} id
         * @param {TeamMemberUpdate} teamMemberUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamMember: function (id, teamMemberUpdate, options) {
            return localVarFp.updateTeamMember(id, teamMemberUpdate, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * TeamApi - object-oriented interface
 * @export
 * @class TeamApi
 * @extends {BaseAPI}
 */
var TeamApi = /** @class */ (function (_super) {
    __extends(TeamApi, _super);
    function TeamApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary add a member to a team
     * @param {string} id
     * @param {BriefTeamMemberDto} briefTeamMemberDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    TeamApi.prototype.addTeamMember = function (id, briefTeamMemberDto, options) {
        var _this = this;
        return exports.TeamApiFp(this.configuration).addTeamMember(id, briefTeamMemberDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary create a team
     * @param {TeamCreation} teamCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    TeamApi.prototype.createTeam = function (teamCreation, options) {
        var _this = this;
        return exports.TeamApiFp(this.configuration).createTeam(teamCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary delete a team
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    TeamApi.prototype.deleteTeam = function (id, options) {
        var _this = this;
        return exports.TeamApiFp(this.configuration).deleteTeam(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List a team\'s custom tools
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    TeamApi.prototype.listTeamTools = function (id, options) {
        var _this = this;
        return exports.TeamApiFp(this.configuration).listTeamTools(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary paginate teams
     * @param {number} page Page index (0-based)
     * @param {number} size Page size
     * @param {string} [id] team id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    TeamApi.prototype.paginateTeams = function (page, size, id, options) {
        var _this = this;
        return exports.TeamApiFp(this.configuration).paginateTeams(page, size, id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary remove a member from a team
     * @param {string} teamId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    TeamApi.prototype.removeMember = function (teamId, userId, options) {
        var _this = this;
        return exports.TeamApiFp(this.configuration).removeMember(teamId, userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary update a team
     * @param {string} id
     * @param {TeamUpdate} teamUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    TeamApi.prototype.updateTeam = function (id, teamUpdate, options) {
        var _this = this;
        return exports.TeamApiFp(this.configuration).updateTeam(id, teamUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary update a member of a team
     * @param {string} id
     * @param {TeamMemberUpdate} teamMemberUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    TeamApi.prototype.updateTeamMember = function (id, teamMemberUpdate, options) {
        var _this = this;
        return exports.TeamApiFp(this.configuration).updateTeamMember(id, teamMemberUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TeamApi;
}(base_1.BaseAPI));
exports.TeamApi = TeamApi;
/**
 * ToolApi - axios parameter creator
 * @export
 */
exports.ToolApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create a tool
         * @param {ToolCreation} toolCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTool: function (toolCreation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'toolCreation' is not null or undefined
                            common_1.assertParamExists('createTool', 'toolCreation', toolCreation);
                            localVarPath = "/api/tool";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(toolCreation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new tool release from a draft
         * @param {string} toolId
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createToolRelease: function (toolId, version, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'toolId' is not null or undefined
                            common_1.assertParamExists('createToolRelease', 'toolId', toolId);
                            // verify required parameter 'version' is not null or undefined
                            common_1.assertParamExists('createToolRelease', 'version', version);
                            localVarPath = "/api/tool/{toolId}/release/{version}"
                                .replace("{" + "toolId" + "}", encodeURIComponent(String(toolId)))
                                .replace("{" + "version" + "}", encodeURIComponent(String(version)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a tool
         * @param {string} toolId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTool: function (toolId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'toolId' is not null or undefined
                            common_1.assertParamExists('deleteTool', 'toolId', toolId);
                            localVarPath = "/api/tool/{toolId}"
                                .replace("{" + "toolId" + "}", encodeURIComponent(String(toolId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a tool release
         * @param {string} toolId
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteToolRelease: function (toolId, version, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'toolId' is not null or undefined
                            common_1.assertParamExists('deleteToolRelease', 'toolId', toolId);
                            // verify required parameter 'version' is not null or undefined
                            common_1.assertParamExists('deleteToolRelease', 'version', version);
                            localVarPath = "/api/tool/{toolId}/release/{version}"
                                .replace("{" + "toolId" + "}", encodeURIComponent(String(toolId)))
                                .replace("{" + "version" + "}", encodeURIComponent(String(version)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a tool by ID
         * @param {string} toolId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTool: function (toolId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'toolId' is not null or undefined
                            common_1.assertParamExists('getTool', 'toolId', toolId);
                            localVarPath = "/api/tool/{toolId}"
                                .replace("{" + "toolId" + "}", encodeURIComponent(String(toolId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all release of a tool
         * @param {string} toolId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToolReleaseByTool: function (toolId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'toolId' is not null or undefined
                            common_1.assertParamExists('getToolReleaseByTool', 'toolId', toolId);
                            localVarPath = "/api/tool/{toolId}/release"
                                .replace("{" + "toolId" + "}", encodeURIComponent(String(toolId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a tool release
         * @param {string} toolId
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToolReleaseByVersion: function (toolId, version, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'toolId' is not null or undefined
                            common_1.assertParamExists('getToolReleaseByVersion', 'toolId', toolId);
                            // verify required parameter 'version' is not null or undefined
                            common_1.assertParamExists('getToolReleaseByVersion', 'version', version);
                            localVarPath = "/api/tool/{toolId}/release/{version}"
                                .replace("{" + "toolId" + "}", encodeURIComponent(String(toolId)))
                                .replace("{" + "version" + "}", encodeURIComponent(String(version)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Paginate tools
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginate: function (page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            common_1.assertParamExists('paginate', 'page', page);
                            // verify required parameter 'size' is not null or undefined
                            common_1.assertParamExists('paginate', 'size', size);
                            localVarPath = "/api/tool";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (size !== undefined) {
                                localVarQueryParameter['size'] = size;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a draft tool release
         * @param {string} toolId
         * @param {ToolReleaseUpdates} toolReleaseUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraftRelease: function (toolId, toolReleaseUpdates, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'toolId' is not null or undefined
                            common_1.assertParamExists('updateDraftRelease', 'toolId', toolId);
                            // verify required parameter 'toolReleaseUpdates' is not null or undefined
                            common_1.assertParamExists('updateDraftRelease', 'toolReleaseUpdates', toolReleaseUpdates);
                            localVarPath = "/api/tool/{toolId}/release/draft"
                                .replace("{" + "toolId" + "}", encodeURIComponent(String(toolId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(toolReleaseUpdates, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a tool
         * @param {string} toolId
         * @param {ToolUpdates} toolUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTool: function (toolId, toolUpdates, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'toolId' is not null or undefined
                            common_1.assertParamExists('updateTool', 'toolId', toolId);
                            // verify required parameter 'toolUpdates' is not null or undefined
                            common_1.assertParamExists('updateTool', 'toolUpdates', toolUpdates);
                            localVarPath = "/api/tool/{toolId}"
                                .replace("{" + "toolId" + "}", encodeURIComponent(String(toolId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(toolUpdates, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ToolApi - functional programming interface
 * @export
 */
exports.ToolApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.ToolApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a tool
         * @param {ToolCreation} toolCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTool: function (toolCreation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createTool(toolCreation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new tool release from a draft
         * @param {string} toolId
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createToolRelease: function (toolId, version, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createToolRelease(toolId, version, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a tool
         * @param {string} toolId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTool: function (toolId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTool(toolId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a tool release
         * @param {string} toolId
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteToolRelease: function (toolId, version, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteToolRelease(toolId, version, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a tool by ID
         * @param {string} toolId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTool: function (toolId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTool(toolId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all release of a tool
         * @param {string} toolId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToolReleaseByTool: function (toolId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getToolReleaseByTool(toolId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a tool release
         * @param {string} toolId
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToolReleaseByVersion: function (toolId, version, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getToolReleaseByVersion(toolId, version, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Paginate tools
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginate: function (page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paginate(page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a draft tool release
         * @param {string} toolId
         * @param {ToolReleaseUpdates} toolReleaseUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraftRelease: function (toolId, toolReleaseUpdates, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDraftRelease(toolId, toolReleaseUpdates, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a tool
         * @param {string} toolId
         * @param {ToolUpdates} toolUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTool: function (toolId, toolUpdates, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateTool(toolId, toolUpdates, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * ToolApi - factory interface
 * @export
 */
exports.ToolApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.ToolApiFp(configuration);
    return {
        /**
         *
         * @summary Create a tool
         * @param {ToolCreation} toolCreation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTool: function (toolCreation, options) {
            return localVarFp.createTool(toolCreation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new tool release from a draft
         * @param {string} toolId
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createToolRelease: function (toolId, version, options) {
            return localVarFp.createToolRelease(toolId, version, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a tool
         * @param {string} toolId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTool: function (toolId, options) {
            return localVarFp.deleteTool(toolId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a tool release
         * @param {string} toolId
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteToolRelease: function (toolId, version, options) {
            return localVarFp.deleteToolRelease(toolId, version, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a tool by ID
         * @param {string} toolId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTool: function (toolId, options) {
            return localVarFp.getTool(toolId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all release of a tool
         * @param {string} toolId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToolReleaseByTool: function (toolId, options) {
            return localVarFp.getToolReleaseByTool(toolId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a tool release
         * @param {string} toolId
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToolReleaseByVersion: function (toolId, version, options) {
            return localVarFp.getToolReleaseByVersion(toolId, version, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Paginate tools
         * @param {number} page Page index (0-based)
         * @param {number} size Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paginate: function (page, size, options) {
            return localVarFp.paginate(page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a draft tool release
         * @param {string} toolId
         * @param {ToolReleaseUpdates} toolReleaseUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraftRelease: function (toolId, toolReleaseUpdates, options) {
            return localVarFp.updateDraftRelease(toolId, toolReleaseUpdates, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a tool
         * @param {string} toolId
         * @param {ToolUpdates} toolUpdates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTool: function (toolId, toolUpdates, options) {
            return localVarFp.updateTool(toolId, toolUpdates, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ToolApi - object-oriented interface
 * @export
 * @class ToolApi
 * @extends {BaseAPI}
 */
var ToolApi = /** @class */ (function (_super) {
    __extends(ToolApi, _super);
    function ToolApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a tool
     * @param {ToolCreation} toolCreation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolApi
     */
    ToolApi.prototype.createTool = function (toolCreation, options) {
        var _this = this;
        return exports.ToolApiFp(this.configuration).createTool(toolCreation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new tool release from a draft
     * @param {string} toolId
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolApi
     */
    ToolApi.prototype.createToolRelease = function (toolId, version, options) {
        var _this = this;
        return exports.ToolApiFp(this.configuration).createToolRelease(toolId, version, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a tool
     * @param {string} toolId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolApi
     */
    ToolApi.prototype.deleteTool = function (toolId, options) {
        var _this = this;
        return exports.ToolApiFp(this.configuration).deleteTool(toolId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a tool release
     * @param {string} toolId
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolApi
     */
    ToolApi.prototype.deleteToolRelease = function (toolId, version, options) {
        var _this = this;
        return exports.ToolApiFp(this.configuration).deleteToolRelease(toolId, version, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a tool by ID
     * @param {string} toolId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolApi
     */
    ToolApi.prototype.getTool = function (toolId, options) {
        var _this = this;
        return exports.ToolApiFp(this.configuration).getTool(toolId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all release of a tool
     * @param {string} toolId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolApi
     */
    ToolApi.prototype.getToolReleaseByTool = function (toolId, options) {
        var _this = this;
        return exports.ToolApiFp(this.configuration).getToolReleaseByTool(toolId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a tool release
     * @param {string} toolId
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolApi
     */
    ToolApi.prototype.getToolReleaseByVersion = function (toolId, version, options) {
        var _this = this;
        return exports.ToolApiFp(this.configuration).getToolReleaseByVersion(toolId, version, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Paginate tools
     * @param {number} page Page index (0-based)
     * @param {number} size Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolApi
     */
    ToolApi.prototype.paginate = function (page, size, options) {
        var _this = this;
        return exports.ToolApiFp(this.configuration).paginate(page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a draft tool release
     * @param {string} toolId
     * @param {ToolReleaseUpdates} toolReleaseUpdates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolApi
     */
    ToolApi.prototype.updateDraftRelease = function (toolId, toolReleaseUpdates, options) {
        var _this = this;
        return exports.ToolApiFp(this.configuration).updateDraftRelease(toolId, toolReleaseUpdates, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a tool
     * @param {string} toolId
     * @param {ToolUpdates} toolUpdates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolApi
     */
    ToolApi.prototype.updateTool = function (toolId, toolUpdates, options) {
        var _this = this;
        return exports.ToolApiFp(this.configuration).updateTool(toolId, toolUpdates, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ToolApi;
}(base_1.BaseAPI));
exports.ToolApi = ToolApi;
/**
 * UsersApi - axios parameter creator
 * @export
 */
exports.UsersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary add position to user
         * @param {string} id
         * @param {UserPositionUpsert} userPositionUpsert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserPosition: function (id, userPositionUpsert, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('addUserPosition', 'id', id);
                            // verify required parameter 'userPositionUpsert' is not null or undefined
                            common_1.assertParamExists('addUserPosition', 'userPositionUpsert', userPositionUpsert);
                            localVarPath = "/api/user/{id}/position"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(userPositionUpsert, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a user by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('getUserById', 'id', id);
                            localVarPath = "/api/user/{id}"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Like an agent
         * @param {string} id
         * @param {string} agentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likeAgent: function (id, agentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('likeAgent', 'id', id);
                            // verify required parameter 'agentId' is not null or undefined
                            common_1.assertParamExists('likeAgent', 'agentId', agentId);
                            localVarPath = "/api/user/{id}/liked-agent"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (agentId !== undefined) {
                                localVarQueryParameter['agentId'] = agentId;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List user\'s liked-agents
         * @param {string} id
         * @param {string} [projectId] Filter - Project ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserLikedAgents: function (id, projectId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('listUserLikedAgents', 'id', id);
                            localVarPath = "/api/user/{id}/liked-agent"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (projectId !== undefined) {
                                localVarQueryParameter['projectId'] = projectId;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List user\'s custom loaders
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserLoaders: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('listUserLoaders', 'id', id);
                            localVarPath = "/api/user/{id}/loader"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List user\'s projects
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserProjects: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('listUserProjects', 'id', id);
                            localVarPath = "/api/user/{id}/project"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List user\'s custom tools
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserTools: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('listUserTools', 'id', id);
                            localVarPath = "/api/user/{id}/tool"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary remove an liked agent
         * @param {string} id
         * @param {string} [agentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLikedAgent: function (id, agentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('removeLikedAgent', 'id', id);
                            localVarPath = "/api/user/{id}/liked-agent"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (agentId !== undefined) {
                                localVarQueryParameter['agentId'] = agentId;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary toggle is onboarding
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleIsOnboarding: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            common_1.assertParamExists('toggleIsOnboarding', 'id', id);
                            localVarPath = "/api/user/{id}/toggle-onboarding"
                                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * UsersApi - functional programming interface
 * @export
 */
exports.UsersApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.UsersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary add position to user
         * @param {string} id
         * @param {UserPositionUpsert} userPositionUpsert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserPosition: function (id, userPositionUpsert, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addUserPosition(id, userPositionUpsert, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a user by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUserById(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Like an agent
         * @param {string} id
         * @param {string} agentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likeAgent: function (id, agentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.likeAgent(id, agentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List user\'s liked-agents
         * @param {string} id
         * @param {string} [projectId] Filter - Project ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserLikedAgents: function (id, projectId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listUserLikedAgents(id, projectId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List user\'s custom loaders
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserLoaders: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listUserLoaders(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List user\'s projects
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserProjects: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listUserProjects(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List user\'s custom tools
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserTools: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listUserTools(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary remove an liked agent
         * @param {string} id
         * @param {string} [agentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLikedAgent: function (id, agentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeLikedAgent(id, agentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary toggle is onboarding
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleIsOnboarding: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.toggleIsOnboarding(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * UsersApi - factory interface
 * @export
 */
exports.UsersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.UsersApiFp(configuration);
    return {
        /**
         *
         * @summary add position to user
         * @param {string} id
         * @param {UserPositionUpsert} userPositionUpsert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserPosition: function (id, userPositionUpsert, options) {
            return localVarFp.addUserPosition(id, userPositionUpsert, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a user by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById: function (id, options) {
            return localVarFp.getUserById(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Like an agent
         * @param {string} id
         * @param {string} agentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        likeAgent: function (id, agentId, options) {
            return localVarFp.likeAgent(id, agentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List user\'s liked-agents
         * @param {string} id
         * @param {string} [projectId] Filter - Project ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserLikedAgents: function (id, projectId, options) {
            return localVarFp.listUserLikedAgents(id, projectId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List user\'s custom loaders
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserLoaders: function (id, options) {
            return localVarFp.listUserLoaders(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List user\'s projects
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserProjects: function (id, options) {
            return localVarFp.listUserProjects(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List user\'s custom tools
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserTools: function (id, options) {
            return localVarFp.listUserTools(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary remove an liked agent
         * @param {string} id
         * @param {string} [agentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLikedAgent: function (id, agentId, options) {
            return localVarFp.removeLikedAgent(id, agentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary toggle is onboarding
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleIsOnboarding: function (id, options) {
            return localVarFp.toggleIsOnboarding(id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
var UsersApi = /** @class */ (function (_super) {
    __extends(UsersApi, _super);
    function UsersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary add position to user
     * @param {string} id
     * @param {UserPositionUpsert} userPositionUpsert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.addUserPosition = function (id, userPositionUpsert, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).addUserPosition(id, userPositionUpsert, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a user by ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.getUserById = function (id, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).getUserById(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Like an agent
     * @param {string} id
     * @param {string} agentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.likeAgent = function (id, agentId, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).likeAgent(id, agentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List user\'s liked-agents
     * @param {string} id
     * @param {string} [projectId] Filter - Project ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.listUserLikedAgents = function (id, projectId, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).listUserLikedAgents(id, projectId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List user\'s custom loaders
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.listUserLoaders = function (id, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).listUserLoaders(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List user\'s projects
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.listUserProjects = function (id, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).listUserProjects(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List user\'s custom tools
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.listUserTools = function (id, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).listUserTools(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary remove an liked agent
     * @param {string} id
     * @param {string} [agentId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.removeLikedAgent = function (id, agentId, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).removeLikedAgent(id, agentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary toggle is onboarding
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.toggleIsOnboarding = function (id, options) {
        var _this = this;
        return exports.UsersApiFp(this.configuration).toggleIsOnboarding(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UsersApi;
}(base_1.BaseAPI));
exports.UsersApi = UsersApi;
/**
 * WebhookBotApi - axios parameter creator
 * @export
 */
exports.WebhookBotApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Generics Bot Webhook
         * @param {string} botId
         * @param {UserMessage} userMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericBotWebhook: function (botId, userMessage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'botId' is not null or undefined
                            common_1.assertParamExists('genericBotWebhook', 'botId', botId);
                            // verify required parameter 'userMessage' is not null or undefined
                            common_1.assertParamExists('genericBotWebhook', 'userMessage', userMessage);
                            localVarPath = "/webhook/bot/{botId}/generics"
                                .replace("{" + "botId" + "}", encodeURIComponent(String(botId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(userMessage, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Slack bot event webhook
         * @param {string} botId
         * @param {SlackEventWrapper} slackEventWrapper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        slackBotEventWebhook: function (botId, slackEventWrapper, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'botId' is not null or undefined
                            common_1.assertParamExists('slackBotEventWebhook', 'botId', botId);
                            // verify required parameter 'slackEventWrapper' is not null or undefined
                            common_1.assertParamExists('slackBotEventWebhook', 'slackEventWrapper', slackEventWrapper);
                            localVarPath = "/webhook/bot/{botId}/slack/event"
                                .replace("{" + "botId" + "}", encodeURIComponent(String(botId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(slackEventWrapper, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Slack bot interactive Webhook
         * @param {string} botId
         * @param {string} payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        slackBotInteractiveWebhook: function (botId, payload, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'botId' is not null or undefined
                            common_1.assertParamExists('slackBotInteractiveWebhook', 'botId', botId);
                            // verify required parameter 'payload' is not null or undefined
                            common_1.assertParamExists('slackBotInteractiveWebhook', 'payload', payload);
                            localVarPath = "/webhook/bot/{botId}/slack/interactive"
                                .replace("{" + "botId" + "}", encodeURIComponent(String(botId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            if (payload !== undefined) {
                                localVarQueryParameter['payload'] = payload;
                            }
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Telegram Bot Webhook
         * @param {string} botId
         * @param {TelegramUpdate} telegramUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telegramBotWebhook: function (botId, telegramUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'botId' is not null or undefined
                            common_1.assertParamExists('telegramBotWebhook', 'botId', botId);
                            // verify required parameter 'telegramUpdate' is not null or undefined
                            common_1.assertParamExists('telegramBotWebhook', 'telegramUpdate', telegramUpdate);
                            localVarPath = "/webhook/bot/{botId}/telegram"
                                .replace("{" + "botId" + "}", encodeURIComponent(String(botId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(telegramUpdate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * WebhookBotApi - functional programming interface
 * @export
 */
exports.WebhookBotApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.WebhookBotApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Generics Bot Webhook
         * @param {string} botId
         * @param {UserMessage} userMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericBotWebhook: function (botId, userMessage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.genericBotWebhook(botId, userMessage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Slack bot event webhook
         * @param {string} botId
         * @param {SlackEventWrapper} slackEventWrapper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        slackBotEventWebhook: function (botId, slackEventWrapper, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.slackBotEventWebhook(botId, slackEventWrapper, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Slack bot interactive Webhook
         * @param {string} botId
         * @param {string} payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        slackBotInteractiveWebhook: function (botId, payload, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.slackBotInteractiveWebhook(botId, payload, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Telegram Bot Webhook
         * @param {string} botId
         * @param {TelegramUpdate} telegramUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telegramBotWebhook: function (botId, telegramUpdate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.telegramBotWebhook(botId, telegramUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * WebhookBotApi - factory interface
 * @export
 */
exports.WebhookBotApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.WebhookBotApiFp(configuration);
    return {
        /**
         *
         * @summary Generics Bot Webhook
         * @param {string} botId
         * @param {UserMessage} userMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genericBotWebhook: function (botId, userMessage, options) {
            return localVarFp.genericBotWebhook(botId, userMessage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Slack bot event webhook
         * @param {string} botId
         * @param {SlackEventWrapper} slackEventWrapper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        slackBotEventWebhook: function (botId, slackEventWrapper, options) {
            return localVarFp.slackBotEventWebhook(botId, slackEventWrapper, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Slack bot interactive Webhook
         * @param {string} botId
         * @param {string} payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        slackBotInteractiveWebhook: function (botId, payload, options) {
            return localVarFp.slackBotInteractiveWebhook(botId, payload, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Telegram Bot Webhook
         * @param {string} botId
         * @param {TelegramUpdate} telegramUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telegramBotWebhook: function (botId, telegramUpdate, options) {
            return localVarFp.telegramBotWebhook(botId, telegramUpdate, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * WebhookBotApi - object-oriented interface
 * @export
 * @class WebhookBotApi
 * @extends {BaseAPI}
 */
var WebhookBotApi = /** @class */ (function (_super) {
    __extends(WebhookBotApi, _super);
    function WebhookBotApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Generics Bot Webhook
     * @param {string} botId
     * @param {UserMessage} userMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookBotApi
     */
    WebhookBotApi.prototype.genericBotWebhook = function (botId, userMessage, options) {
        var _this = this;
        return exports.WebhookBotApiFp(this.configuration).genericBotWebhook(botId, userMessage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Slack bot event webhook
     * @param {string} botId
     * @param {SlackEventWrapper} slackEventWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookBotApi
     */
    WebhookBotApi.prototype.slackBotEventWebhook = function (botId, slackEventWrapper, options) {
        var _this = this;
        return exports.WebhookBotApiFp(this.configuration).slackBotEventWebhook(botId, slackEventWrapper, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Slack bot interactive Webhook
     * @param {string} botId
     * @param {string} payload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookBotApi
     */
    WebhookBotApi.prototype.slackBotInteractiveWebhook = function (botId, payload, options) {
        var _this = this;
        return exports.WebhookBotApiFp(this.configuration).slackBotInteractiveWebhook(botId, payload, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Telegram Bot Webhook
     * @param {string} botId
     * @param {TelegramUpdate} telegramUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookBotApi
     */
    WebhookBotApi.prototype.telegramBotWebhook = function (botId, telegramUpdate, options) {
        var _this = this;
        return exports.WebhookBotApiFp(this.configuration).telegramBotWebhook(botId, telegramUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return WebhookBotApi;
}(base_1.BaseAPI));
exports.WebhookBotApi = WebhookBotApi;
/**
 * WebhookLoaderApi - axios parameter creator
 * @export
 */
exports.WebhookLoaderApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Loader Callback - Close
         * @param {LoaderCloseCallbackBody} loaderCloseCallbackBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loaderClose: function (loaderCloseCallbackBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loaderCloseCallbackBody' is not null or undefined
                            common_1.assertParamExists('loaderClose', 'loaderCloseCallbackBody', loaderCloseCallbackBody);
                            localVarPath = "/webhook/loader/callback/close";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(loaderCloseCallbackBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Loader Callback - Delete
         * @param {LoaderDeleteCallbackBody} loaderDeleteCallbackBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loaderDelete: function (loaderDeleteCallbackBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loaderDeleteCallbackBody' is not null or undefined
                            common_1.assertParamExists('loaderDelete', 'loaderDeleteCallbackBody', loaderDeleteCallbackBody);
                            localVarPath = "/webhook/loader/callback/delete";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(loaderDeleteCallbackBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Loader Callback - Upsert
         * @param {LoaderUpsertCallbackBody} loaderUpsertCallbackBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loaderUpsert: function (loaderUpsertCallbackBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loaderUpsertCallbackBody' is not null or undefined
                            common_1.assertParamExists('loaderUpsert', 'loaderUpsertCallbackBody', loaderUpsertCallbackBody);
                            localVarPath = "/webhook/loader/callback/upsert";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(loaderUpsertCallbackBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * WebhookLoaderApi - functional programming interface
 * @export
 */
exports.WebhookLoaderApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.WebhookLoaderApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Loader Callback - Close
         * @param {LoaderCloseCallbackBody} loaderCloseCallbackBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loaderClose: function (loaderCloseCallbackBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loaderClose(loaderCloseCallbackBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Loader Callback - Delete
         * @param {LoaderDeleteCallbackBody} loaderDeleteCallbackBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loaderDelete: function (loaderDeleteCallbackBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loaderDelete(loaderDeleteCallbackBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Loader Callback - Upsert
         * @param {LoaderUpsertCallbackBody} loaderUpsertCallbackBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loaderUpsert: function (loaderUpsertCallbackBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loaderUpsert(loaderUpsertCallbackBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * WebhookLoaderApi - factory interface
 * @export
 */
exports.WebhookLoaderApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.WebhookLoaderApiFp(configuration);
    return {
        /**
         *
         * @summary Loader Callback - Close
         * @param {LoaderCloseCallbackBody} loaderCloseCallbackBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loaderClose: function (loaderCloseCallbackBody, options) {
            return localVarFp.loaderClose(loaderCloseCallbackBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Loader Callback - Delete
         * @param {LoaderDeleteCallbackBody} loaderDeleteCallbackBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loaderDelete: function (loaderDeleteCallbackBody, options) {
            return localVarFp.loaderDelete(loaderDeleteCallbackBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Loader Callback - Upsert
         * @param {LoaderUpsertCallbackBody} loaderUpsertCallbackBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loaderUpsert: function (loaderUpsertCallbackBody, options) {
            return localVarFp.loaderUpsert(loaderUpsertCallbackBody, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * WebhookLoaderApi - object-oriented interface
 * @export
 * @class WebhookLoaderApi
 * @extends {BaseAPI}
 */
var WebhookLoaderApi = /** @class */ (function (_super) {
    __extends(WebhookLoaderApi, _super);
    function WebhookLoaderApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Loader Callback - Close
     * @param {LoaderCloseCallbackBody} loaderCloseCallbackBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookLoaderApi
     */
    WebhookLoaderApi.prototype.loaderClose = function (loaderCloseCallbackBody, options) {
        var _this = this;
        return exports.WebhookLoaderApiFp(this.configuration).loaderClose(loaderCloseCallbackBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Loader Callback - Delete
     * @param {LoaderDeleteCallbackBody} loaderDeleteCallbackBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookLoaderApi
     */
    WebhookLoaderApi.prototype.loaderDelete = function (loaderDeleteCallbackBody, options) {
        var _this = this;
        return exports.WebhookLoaderApiFp(this.configuration).loaderDelete(loaderDeleteCallbackBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Loader Callback - Upsert
     * @param {LoaderUpsertCallbackBody} loaderUpsertCallbackBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookLoaderApi
     */
    WebhookLoaderApi.prototype.loaderUpsert = function (loaderUpsertCallbackBody, options) {
        var _this = this;
        return exports.WebhookLoaderApiFp(this.configuration).loaderUpsert(loaderUpsertCallbackBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return WebhookLoaderApi;
}(base_1.BaseAPI));
exports.WebhookLoaderApi = WebhookLoaderApi;
/**
 * WebhookToolApi - axios parameter creator
 * @export
 */
exports.WebhookToolApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Tool command callback
         * @param {CommandCallbackBody} commandCallbackBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandCallback: function (commandCallbackBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'commandCallbackBody' is not null or undefined
                            common_1.assertParamExists('commandCallback', 'commandCallbackBody', commandCallbackBody);
                            localVarPath = "/webhook/tool/callback";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth required
                            // oauth required
                            return [4 /*yield*/, common_1.setOAuthToObject(localVarHeaderParameter, "OAuth", [], configuration)];
                        case 1:
                            // authentication OAuth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = common_1.serializeDataIfNeeded(commandCallbackBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: common_1.toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * WebhookToolApi - functional programming interface
 * @export
 */
exports.WebhookToolApiFp = function (configuration) {
    var localVarAxiosParamCreator = exports.WebhookToolApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Tool command callback
         * @param {CommandCallbackBody} commandCallbackBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandCallback: function (commandCallbackBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.commandCallback(commandCallbackBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * WebhookToolApi - factory interface
 * @export
 */
exports.WebhookToolApiFactory = function (configuration, basePath, axios) {
    var localVarFp = exports.WebhookToolApiFp(configuration);
    return {
        /**
         *
         * @summary Tool command callback
         * @param {CommandCallbackBody} commandCallbackBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandCallback: function (commandCallbackBody, options) {
            return localVarFp.commandCallback(commandCallbackBody, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * WebhookToolApi - object-oriented interface
 * @export
 * @class WebhookToolApi
 * @extends {BaseAPI}
 */
var WebhookToolApi = /** @class */ (function (_super) {
    __extends(WebhookToolApi, _super);
    function WebhookToolApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Tool command callback
     * @param {CommandCallbackBody} commandCallbackBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookToolApi
     */
    WebhookToolApi.prototype.commandCallback = function (commandCallbackBody, options) {
        var _this = this;
        return exports.WebhookToolApiFp(this.configuration).commandCallback(commandCallbackBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return WebhookToolApi;
}(base_1.BaseAPI));
exports.WebhookToolApi = WebhookToolApi;
